// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import ReactDOM from 'react-dom';
// import './AwardNominations.css';

// // Exact 9 award categories structured by 3 sections as specified by user
// const AWARD_GROUPS = [
//     {
//         groupNumber: '1',
//         groupTitle: 'Overall Company Awards',
//         groupIcon: '👑',
//         countLabel: '4 Awards',
//         groupDesc: 'Highest organizational honors celebrating year-round individual leadership, customer impact, and exceptional dedication.',
//         categories: [
//             {
//                 id: 'emp-of-year',
//                 name: 'Employee of the Year',
//                 icon: '🌟',
//                 badge: 'Grand Honor',
//                 description: "Recognizes an employee who has consistently demonstrated exceptional performance, dedication, and impact throughout the year. This award celebrates outstanding contributions that have significantly advanced the company's goals and values."
//             },
//             {
//                 id: 'leadership-excellence',
//                 name: 'Leadership Excellence Award',
//                 icon: '🏆',
//                 badge: 'Leadership Honor',
//                 description: 'Honors an individual who inspires, empowers, and leads others to achieve outstanding results. This award recognizes exemplary leadership, decision-making, and commitment to developing people and fostering a positive work culture.'
//             },
//             {
//                 id: 'rising-star',
//                 name: 'Rising Star Award',
//                 icon: '🚀',
//                 badge: 'Emerging Talent',
//                 description: 'Recognizes a high-potential employee who has shown remarkable growth, initiative, and achievement in a short period. This award celebrates emerging talent and future leaders who make a meaningful impact on the organization.'
//             },
//             {
//                 id: 'customer-excellence-champion',
//                 name: 'Customer Excellence Champion Award',
//                 icon: '🤝',
//                 badge: 'Client Impact',
//                 description: 'Honors an employee who consistently goes above and beyond to deliver exceptional customer experiences. This award recognizes a strong commitment to understanding customer needs, building trust, and driving customer satisfaction.'
//             }
//         ]
//     },
//     {
//         groupNumber: '2',
//         groupTitle: 'Team-Wise Awards',
//         groupIcon: '💎',
//         countLabel: '4 Awards',
//         groupDesc: 'Honoring departmental excellence, team collaboration, quality standards, and mentorship.',
//         categories: [
//             {
//                 id: 'team-player',
//                 name: 'Team Player Award',
//                 icon: '❤️',
//                 badge: 'Collaboration',
//                 description: 'Recognizes an employee who consistently collaborates effectively and supports colleagues to achieve shared goals. This award celebrates individuals who foster teamwork, positivity, and a spirit of cooperation.'
//             },
//             {
//                 id: 'quality-champion',
//                 name: 'Quality Champion Award',
//                 icon: '🎯',
//                 badge: 'Quality & Precision',
//                 description: 'Honors an employee who demonstrates an unwavering commitment to quality and continuous improvement. This award recognizes those who maintain high standards and help ensure excellence in every aspect of their work.'
//             },
//             {
//                 id: 'ownership-excellence',
//                 name: 'Ownership Excellence Award',
//                 icon: '⚡',
//                 badge: 'Accountability',
//                 description: 'Recognizes an employee who takes full accountability for their responsibilities and proactively drives results. This award celebrates individuals who demonstrate initiative, reliability, and a strong sense of ownership.'
//             },
//             {
//                 id: 'mentor-of-year',
//                 name: 'Mentor of the Year Award',
//                 icon: '💡',
//                 badge: 'Mentorship',
//                 description: 'Honors an employee who has made a significant impact through coaching, guiding, and developing others. This award recognizes dedication to sharing knowledge, supporting growth, and helping colleagues achieve success.'
//             }
//         ]
//     },
//     {
//         groupNumber: '3',
//         groupTitle: 'Best Team Award',
//         groupIcon: '🏆',
//         countLabel: '1 Award (Management Selection)',
//         groupDesc: 'Recognizes overall team achievements, evaluated and selected directly by Management leadership.',
//         categories: [
//             {
//                 id: 'team-excellence',
//                 name: 'Team Excellence Award',
//                 icon: '🎖️',
//                 badge: 'Management Selection',
//                 isManagementOnly: true,
//                 description: 'Recognizes a team that has demonstrated outstanding collaboration, innovation, and performance in achieving its objectives. This award celebrates collective success, cross-functional teamwork, and the ability to deliver exceptional results together.'
//             }
//         ]
//     }
// ];

// // Flat array of all categories
// const ALL_CATEGORIES = AWARD_GROUPS.flatMap(g => g.categories);

// const DEFAULT_HALL_OF_FAME = [
//     {
//         id: 'hof-1',
//         winnerName: 'Aarav Sharma',
//         role: 'Senior Fullstack Lead',
//         awardTitle: 'Employee of the Year 2025',
//         icon: '🌟',
//         citation: 'Consistently demonstrated exceptional performance, dedication, and measurable impact.'
//     },
//     {
//         id: 'hof-2',
//         winnerName: 'Priya Patel',
//         role: 'Project Lead',
//         awardTitle: 'Leadership Excellence Award 2025',
//         icon: '🏆',
//         citation: 'Empowered project teams through exceptional leadership and strategic execution.'
//     }
// ];

// const AwardNominations = ({ userData, role = 'Employee', theme: themeProp }) => {
//     const currentUserName = userData ? `${userData.firstName || ''} ${userData.lastName || ''}`.trim() || 'Employee User' : 'Employee User';

//     // Dynamic theme state detection (Dark / Light)
//     const [isDarkTheme, setIsDarkTheme] = useState(() => {
//         if (themeProp === 'dark') return true;
//         if (themeProp === 'light') return false;
//         const dataTheme = document.documentElement.getAttribute('data-theme');
//         if (dataTheme === 'dark') return true;
//         if (dataTheme === 'light') return false;
//         const bodyClass = document.body.className || '';
//         if (bodyClass.includes('dark')) return true;
//         const localTheme = localStorage.getItem('theme') || localStorage.getItem('dashboard-theme');
//         return localTheme === 'dark';
//     });

//     useEffect(() => {
//         const checkTheme = () => {
//             if (themeProp === 'dark') { setIsDarkTheme(true); return; }
//             if (themeProp === 'light') { setIsDarkTheme(false); return; }
//             const dataTheme = document.documentElement.getAttribute('data-theme');
//             if (dataTheme === 'dark') { setIsDarkTheme(true); return; }
//             if (dataTheme === 'light') { setIsDarkTheme(false); return; }
//             const bodyClass = document.body.className || '';
//             const localTheme = localStorage.getItem('theme') || localStorage.getItem('dashboard-theme');
//             const dark = bodyClass.includes('dark') || localTheme === 'dark';
//             setIsDarkTheme(dark);
//         };

//         checkTheme();
//         const observer = new MutationObserver(checkTheme);
//         observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme', 'class'] });
//         observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

//         return () => observer.disconnect();
//     }, [themeProp]);

//     // Multi-page navigation state: 'page-1-intro', 'page-2-categories', 'page-3-my-submissions', 'page-4-endorsements', 'page-5-admin', 'page-6-hall-of-fame'
//     const [currentPage, setCurrentPage] = useState('page-1-intro');

//     // Database employee list
//     const [dbEmployees, setDbEmployees] = useState([]);

//     // Teams state for 3 featured teams
//     const [awardTeams, setAwardTeams] = useState([
//         {
//             team_key: 'software_team',
//             team_name: 'Software Team',
//             icon: '💻',
//             departments: ['LTDM PC', 'GTE-Technology Operations'],
//             employees: []
//         },
//         {
//             team_key: 'bim_team',
//             team_name: 'BIM Team',
//             icon: '🏗️',
//             departments: ['FSPLO', 'DDI', 'DMS', 'FI-IE'],
//             employees: []
//         },
//         {
//             team_key: 'fi_design_team',
//             team_name: 'FI Design Team',
//             icon: '🎨',
//             departments: ['FI Design', 'LTO'],
//             employees: []
//         }
//     ]);

//     // Nominations state
//     const [nominations, setNominations] = useState(() => {
//         const saved = localStorage.getItem('gte_3rd_anniversary_nominations');
//         return saved ? JSON.parse(saved) : [
//             {
//                 id: 'nom-301',
//                 nomineeName: 'Priya Patel',
//                 nomineeRole: 'Senior Analyst',
//                 categoryId: 'emp-of-year',
//                 categoryName: 'Employee of the Year',
//                 nominatorName: 'Rohan Mehta',
//                 nominatorRole: 'Manager',
//                 reason: 'Consistently exceeded performance metrics and demonstrated extraordinary commitment to corporate growth.',
//                 status: 'PENDING_REVIEW',
//                 submittedAt: '2026-09-02'
//             }
//         ];
//     });

//     const [hallOfFame, setHallOfFame] = useState(() => {
//         const saved = localStorage.getItem('gte_3rd_anniversary_hof');
//         return saved ? JSON.parse(saved) : DEFAULT_HALL_OF_FAME;
//     });

//     // Modal state for nominating
//     const [showNominateModal, setShowNominateModal] = useState(false);
//     const [selectedCategory, setSelectedCategory] = useState(ALL_CATEGORIES[0]);
//     const [empSearchQuery, setEmpSearchQuery] = useState('');
//     const [isEmpDropdownOpen, setIsEmpDropdownOpen] = useState(false);
//     const empDropdownRef = useRef(null);

//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (empDropdownRef.current && !empDropdownRef.current.contains(e.target)) {
//                 setIsEmpDropdownOpen(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     const [formData, setFormData] = useState({
//         nomineeName: '',
//         nomineeRole: '',
//         categoryId: ALL_CATEGORIES[0].id,
//         reason: ''
//     });

//     // Manager endorsement modal state
//     const [endorseModalItem, setEndorseModalItem] = useState(null);
//     const [endorsementComment, setEndorsementComment] = useState('');

//     // Logged in user identifiers for self-nomination prevention
//     const loggedInUserIdentifiers = React.useMemo(() => {
//         const names = new Set();
//         const ids = new Set();

//         const processUserObj = (obj) => {
//             if (!obj || typeof obj !== 'object') return;
//             if (obj.id) ids.add(String(obj.id).toLowerCase().trim());
//             if (obj.EmpId) ids.add(String(obj.EmpId).toLowerCase().trim());
//             if (obj.emp_id) ids.add(String(obj.emp_id).toLowerCase().trim());

//             const fn = (obj.firstName || obj.FirstName || '').trim();
//             const ln = (obj.lastName || obj.LastName || '').trim();
//             const fullName = (obj.fullName || obj.name || '').trim();

//             if (fn && ln) names.add(`${fn} ${ln}`.toLowerCase());
//             if (fullName) names.add(fullName.toLowerCase());
//             if (fn) names.add(fn.toLowerCase());
//         };

//         processUserObj(userData);

//         try {
//             const localUser = JSON.parse(localStorage.getItem('userData') || localStorage.getItem('user') || '{}');
//             processUserObj(localUser);
//         } catch (e) { }

//         if (currentUserName && currentUserName !== 'Employee User') {
//             names.add(currentUserName.trim().toLowerCase());
//         }

//         return { names, ids };
//     }, [userData, currentUserName]);

//     // Master employee options list combining database employees and team rosters
//     const allEmployeeOptions = React.useMemo(() => {
//         const map = new Map();
//         // Add from dbEmployees
//         dbEmployees.forEach(emp => {
//             const name = emp.full_name || `${emp.FirstName || ''} ${emp.LastName || ''}`.trim();
//             if (name && !map.has(name)) {
//                 map.set(name, {
//                     id: emp.id || emp.EmpId || '',
//                     name,
//                     role: emp.Designation || emp.designation || emp.Department || emp.department || 'Team Member',
//                     dept: emp.Department || emp.department || ''
//                 });
//             }
//         });
//         // Add from awardTeams
//         awardTeams.forEach(t => {
//             (t.employees || []).forEach(emp => {
//                 const name = emp.full_name || `${emp.first_name || ''} ${emp.last_name || ''}`.trim();
//                 if (name && !map.has(name)) {
//                     map.set(name, {
//                         id: emp.id || emp.EmpId || '',
//                         name,
//                         role: emp.designation || t.team_name || 'Team Member',
//                         dept: emp.department || ''
//                     });
//                 }
//             });
//         });
//         // Fallback default list if database response is loading/empty
//         if (map.size === 0) {
//             [
//                 { id: '', name: 'Aarav Sharma', role: 'Senior Lead', dept: 'Software Team' },
//                 { id: '', name: 'Priya Patel', role: 'Project Analyst', dept: 'BIM Team' },
//                 { id: '', name: 'Rohan Mehta', role: 'Design Lead', dept: 'FI Design Team' },
//                 { id: '', name: 'Vikram Singh', role: 'BIM Specialist', dept: 'BIM Team' },
//                 { id: '', name: 'Ananya Roy', role: 'Tech Operations', dept: 'Software Team' }
//             ].forEach(emp => map.set(emp.name, emp));
//         }

//         let list = Array.from(map.values());

//         // Exclude specified people from every award nomination employee list:
//         // 1) Ankur Patil, 2) Shubham Patil, 3) Neeta Sangvikar, 4) Ganesh Gorakh Chavan, 5) Rakesh Sharma (specifically Rakesh Sharma, leaving Rakesh GS), 6) Sandeep Potti, 7) Aron Fisher, 8) Sunita Shantaram Patil, 9) Shantaram Patil
//         list = list.filter(emp => {
//             const nameLower = (emp.name || '').trim().toLowerCase();
//             const isExcluded =
//                 nameLower.includes('ankur') ||
//                 nameLower.includes('shubham') ||
//                 nameLower.includes('neeta') ||
//                 nameLower.includes('ganesh') ||
//                 (nameLower.includes('rakesh') && nameLower.includes('sharma')) ||
//                 nameLower.includes('sandeep') ||
//                 nameLower.includes('potti') ||
//                 nameLower.includes('aron') ||
//                 nameLower.includes('fisher') ||
//                 nameLower.includes('sunita') ||
//                 nameLower.includes('shantaram');
//             return !isExcluded;
//         });

//         // Filter out logged in user to prevent self nomination
//         list = list.filter(emp => {
//             const empNameLower = emp.name.trim().toLowerCase();
//             const empIdLower = emp.id ? String(emp.id).toLowerCase().trim() : '';

//             // 1. Check ID match
//             if (empIdLower && loggedInUserIdentifiers.ids.has(empIdLower)) {
//                 return false;
//             }

//             // 2. Check exact name match in loggedInUserIdentifiers.names
//             if (loggedInUserIdentifiers.names.has(empNameLower)) {
//                 return false;
//             }

//             // 3. Check partial name matches (e.g. if user is "Nisha" and employee is "Nisha Patel" or vice versa)
//             for (let name of loggedInUserIdentifiers.names) {
//                 if (!name || name === 'employee user' || name === 'employee') continue;
//                 if (empNameLower === name) return false;
//                 if (name.length >= 3 && (empNameLower.startsWith(name + ' ') || name.startsWith(empNameLower + ' '))) {
//                     return false;
//                 }
//             }

//             return true;
//         });

//         return list.sort((a, b) => a.name.localeCompare(b.name));
//     }, [dbEmployees, awardTeams, loggedInUserIdentifiers]);

//     // Live search filter for employee selector list
//     const filteredEmpOptions = useMemo(() => {
//         let list = allEmployeeOptions;

//         if (!empSearchQuery) return list;
//         const q = empSearchQuery.toLowerCase().trim();
//         return list.filter(o =>
//             o.name.toLowerCase().includes(q) ||
//             (o.dept && o.dept.toLowerCase().includes(q)) ||
//             (o.role && o.role.toLowerCase().includes(q))
//         );
//     }, [allEmployeeOptions, empSearchQuery]);

//     // Fetch employee list from backend get_employees.php
//     useEffect(() => {
//         fetch('/gt-api/get_employees.php', { credentials: 'include' })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success && Array.isArray(data.employees)) {
//                     setDbEmployees(data.employees);
//                 }
//             })
//             .catch(() => { });
//     }, []);

//     // Fetch 3 teams and roster from backend get_teams.php
//     useEffect(() => {
//         fetch('/gt-api/get_teams.php', { credentials: 'include' })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success && Array.isArray(data.teams) && data.teams.length > 0) {
//                     const iconMap = {
//                         'software_team': '💻',
//                         'bim_team': '🏗️',
//                         'fi_design_team': '🎨'
//                     };
//                     const updated = data.teams.map(t => ({
//                         ...t,
//                         icon: iconMap[t.team_key] || '👥'
//                     }));
//                     setAwardTeams(updated);
//                 }
//             })
//             .catch(err => console.error('Failed to fetch award teams:', err));
//     }, []);

//     // Fetch nominations from database elmsdb via backend get_award_nominations.php
//     useEffect(() => {
//         fetch('/gt-api/get_award_nominations.php', { credentials: 'include' })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success && Array.isArray(data.nominations) && data.nominations.length > 0) {
//                     setNominations(data.nominations);
//                 }
//             })
//             .catch(err => console.error('Failed to fetch award nominations from elmsdb database:', err));
//     }, []);

//     useEffect(() => {
//         localStorage.setItem('gte_3rd_anniversary_nominations', JSON.stringify(nominations));
//     }, [nominations]);

//     useEffect(() => {
//         localStorage.setItem('gte_3rd_anniversary_hof', JSON.stringify(hallOfFame));
//     }, [hallOfFame]);

//     const handleOpenNominate = (category) => {
//         const cat = category || ALL_CATEGORIES[0];
//         setSelectedCategory(cat);
//         setEmpSearchQuery('');
//         setIsEmpDropdownOpen(false);

//         // Check if current user already nominated someone for this category
//         const existing = nominations.find(n =>
//             n.categoryId === cat.id &&
//             n.nominatorName.toLowerCase() === currentUserName.toLowerCase()
//         );

//         if (existing) {
//             setFormData({
//                 nomineeName: existing.nomineeName || '',
//                 nomineeRole: existing.nomineeRole || '',
//                 categoryId: cat.id,
//                 reason: existing.reason || ''
//             });
//         } else {
//             setFormData({
//                 nomineeName: '',
//                 nomineeRole: '',
//                 categoryId: cat.id,
//                 reason: ''
//             });
//         }
//         setShowNominateModal(true);
//     };

//     const handleSubmitNomination = (e) => {
//         e.preventDefault();
//         if (!formData.nomineeName || !formData.reason) {
//             alert('Please enter the nominee name and reason for nomination.');
//             return;
//         }

//         // Self-nomination validation
//         const nomineeLower = formData.nomineeName.trim().toLowerCase();
//         for (let name of loggedInUserIdentifiers.names) {
//             if (name && name !== 'employee user' && name !== 'employee') {
//                 if (nomineeLower === name || (name.length >= 3 && nomineeLower.startsWith(name + ' '))) {
//                     alert('Self-nomination is not allowed. You cannot nominate yourself for an award.');
//                     return;
//                 }
//             }
//         }

//         const categoryObj = ALL_CATEGORIES.find(c => c.id === formData.categoryId) || selectedCategory;

//         const newNomination = {
//             nomineeName: formData.nomineeName,
//             nomineeRole: formData.nomineeRole || 'Team Member',
//             categoryId: categoryObj.id,
//             categoryName: categoryObj.name,
//             nominatorName: currentUserName,
//             nominatorRole: role,
//             reason: formData.reason,
//             status: 'PENDING_REVIEW',
//             submittedAt: new Date().toISOString().split('T')[0]
//         };

//         // Submit to database elmsdb via PHP API
//         fetch('/gt-api/save_award_nomination.php', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(newNomination),
//             credentials: 'include'
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success && data.nomination) {
//                     setNominations(prev => {
//                         const filtered = prev.filter(n => !(n.categoryId === categoryObj.id && n.nominatorName.toLowerCase() === currentUserName.toLowerCase()));
//                         return [data.nomination, ...filtered];
//                     });
//                 } else {
//                     const fallbackNom = { ...newNomination, id: `nom-${Date.now()}` };
//                     setNominations(prev => {
//                         const filtered = prev.filter(n => !(n.categoryId === categoryObj.id && n.nominatorName.toLowerCase() === currentUserName.toLowerCase()));
//                         return [fallbackNom, ...filtered];
//                     });
//                 }
//             })
//             .catch(err => {
//                 console.error("Save nomination API error, fallback to local:", err);
//                 const fallbackNom = { ...newNomination, id: `nom-${Date.now()}` };
//                 setNominations(prev => {
//                     const filtered = prev.filter(n => !(n.categoryId === categoryObj.id && n.nominatorName.toLowerCase() === currentUserName.toLowerCase()));
//                     return [fallbackNom, ...filtered];
//                 });
//             });

//         setShowNominateModal(false);
//         alert(`🎉 Nomination for "${formData.nomineeName}" submitted successfully!`);
//     };

//     // Manager Action: Endorse Nomination
//     const handleEndorseNomination = (nominationId) => {
//         const comment = endorsementComment || 'Strongly endorsed by manager.';

//         fetch('/gt-api/update_award_nomination_status.php', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//                 id: nominationId,
//                 status: 'MANAGER_ENDORSED',
//                 endorsementComment: comment
//             }),
//             credentials: 'include'
//         }).catch(err => console.error("Failed to update status in DB:", err));

//         setNominations(prev => prev.map(item => {
//             if (item.id === nominationId) {
//                 return {
//                     ...item,
//                     status: 'MANAGER_ENDORSED',
//                     endorsementComment: comment
//                 };
//             }
//             return item;
//         }));
//         setEndorseModalItem(null);
//         setEndorsementComment('');
//     };

//     // Management Action: Declare Winner
//     const handleDeclareWinner = (item) => {
//         if (window.confirm(`Declare ${item.nomineeName} as WINNER for "${item.categoryName}"?`)) {

//             fetch('/gt-api/update_award_nomination_status.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     id: item.id,
//                     status: 'WINNER_DECLARED'
//                 }),
//                 credentials: 'include'
//             }).catch(err => console.error("Failed to update winner status in DB:", err));

//             setNominations(prev => prev.map(n => n.id === item.id ? { ...n, status: 'WINNER_DECLARED' } : n));

//             const newWinner = {
//                 id: `hof-${Date.now()}`,
//                 winnerName: item.nomineeName,
//                 role: item.nomineeRole,
//                 awardTitle: `${item.categoryName} - 3rd Anniversary Honors`,
//                 icon: '🏆',
//                 citation: item.reason
//             };
//             setHallOfFame(prev => [newWinner, ...prev]);
//         }
//     };

//     // Filtered nominations
//     const mySubmissions = nominations.filter(n => n.nominatorName.toLowerCase() === currentUserName.toLowerCase());
//     const pendingEndorsements = nominations.filter(n => n.status === 'PENDING_REVIEW');

//     // Management Dashboard Analytics Computations
//     const analyticsStats = useMemo(() => {
//         const total = nominations.length;
//         const pending = nominations.filter(n => n.status === 'PENDING_REVIEW').length;
//         const endorsed = nominations.filter(n => n.status === 'MANAGER_ENDORSED').length;
//         const winners = nominations.filter(n => n.status === 'WINNER_DECLARED').length;

//         // Count per category
//         const catMap = {};
//         ALL_CATEGORIES.forEach(c => {
//             catMap[c.id] = { id: c.id, name: c.name, icon: c.icon, badge: c.badge, count: 0 };
//         });
//         nominations.forEach(n => {
//             if (catMap[n.categoryId]) {
//                 catMap[n.categoryId].count++;
//             } else {
//                 catMap[n.categoryId] = { id: n.categoryId, name: n.categoryName || n.categoryId, icon: '🏆', badge: 'Award', count: 1 };
//             }
//         });

//         const categoryBreakdown = Object.values(catMap).sort((a, b) => b.count - a.count);

//         // Top Nominated Employees Leaderboard
//         const nomMap = {};
//         nominations.forEach(n => {
//             const key = (n.nomineeName || '').trim();
//             if (!key) return;
//             if (!nomMap[key]) {
//                 nomMap[key] = {
//                     name: key,
//                     role: n.nomineeRole || 'Team Member',
//                     count: 0,
//                     categories: new Set()
//                 };
//             }
//             nomMap[key].count++;
//             nomMap[key].categories.add(n.categoryName);
//         });

//         const topNominees = Object.values(nomMap)
//             .map(item => ({ ...item, categories: Array.from(item.categories) }))
//             .sort((a, b) => b.count - a.count)
//             .slice(0, 5);

//         return {
//             total,
//             pending,
//             endorsed,
//             winners,
//             categoryBreakdown,
//             topNominees
//         };
//     }, [nominations]);

//     const pagesList = [
//         { id: 'page-1-intro', title: '1. Event Intro & Award Guide', icon: '🎊' },
//         { id: 'page-2-categories', title: '2. Award Nominations Grid', icon: '🏆' },
//         { id: 'page-3-my-submissions', title: '3. My Submissions', icon: '📜' },
//         ...(role === 'Manager' || role === 'Management' ? [{ id: 'page-4-endorsements', title: '4. Team Endorsements', icon: '👥' }] : []),
//         ...(role === 'Management' ? [{ id: 'page-5-admin', title: '5. Ceremony Admin', icon: '⚙️' }] : []),
//         { id: 'page-6-hall-of-fame', title: '6. Wall of Fame', icon: '🌟' }
//     ];

//     const currentPageIndex = pagesList.findIndex(p => p.id === currentPage);

//     return (
//         <div className={`award-container ${isDarkTheme ? 'dark-theme' : 'light-theme'}`}>
//             {/* PAGE 1: CLASSIC EVENT INTRO, TEAM CATEGORIZATION & AWARD GUIDE */}
//             {currentPage === 'page-1-intro' && (
//                 <div className="classic-intro-page">
//                     {/* ANIMATED CLASSIC HERO TITLE SECTION */}
//                     <header className="classic-hero-banner">
//                         <div className="classic-badge-pill">
//                             ✨ Genesis Tech Engineers • 3rd Anniversary & Award Ceremony
//                         </div>
//                         <h1 className="classic-main-title">
//                             Celebrating 3 Years of Excellence
//                         </h1>
//                         <div className="classic-gold-divider"></div>
//                         <p className="classic-lead-text">
//                             Welcome to the official 3rd Anniversary Excellence Award. Explore how our departments and teams are structured, read the detailed meanings of all 9 company awards, and nominate outstanding colleagues.
//                         </p>
//                     </header>

//                     {/* SECTION 1: AWARDS & THEIR DETAILED MEANINGS (TOP) */}
//                     <section className="classic-section">
//                         <div className="classic-section-header">
//                             <h2 className="classic-section-title">
//                                 🏆Award Categories & Criteria
//                             </h2>
//                             <p className="classic-section-subtitle">
//                                 Complete criteria and official meanings for all 9 awards across our 3 honor groups.
//                             </p>
//                         </div>

//                         {AWARD_GROUPS.map((group) => (
//                             <div key={group.groupNumber} className="classic-award-group">
//                                 <div className="classic-group-heading">
//                                     <span className="classic-group-num">{group.groupIcon} Group {group.groupNumber}</span>
//                                     <h3 className="classic-group-title">{group.groupTitle}</h3>
//                                     <span className="classic-group-tag">{group.countLabel}</span>
//                                 </div>
//                                 <p className="classic-group-desc">{group.groupDesc}</p>

//                                 <div className="classic-awards-linear-list">
//                                     {group.categories.map((cat) => {
//                                         const existingNom = nominations.find(n =>
//                                             n.categoryId === cat.id &&
//                                             (n.nominatorName || '').toLowerCase() === currentUserName.toLowerCase()
//                                         );
//                                         return (
//                                             <div key={cat.id} className="classic-award-item">
//                                                 <div className="classic-award-header-line">
//                                                     <h4 className="classic-award-name">
//                                                         <span className="cat-icon-bullet">{cat.icon}</span> {cat.name}
//                                                     </h4>
//                                                     <div className="classic-award-actions" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
//                                                         {cat.isManagementOnly ? (
//                                                             <span style={{
//                                                                 background: isDarkTheme ? 'rgba(234, 179, 8, 0.15)' : '#fffbe8',
//                                                                 color: isDarkTheme ? '#fde047' : '#92400e',
//                                                                 border: isDarkTheme ? '1px solid rgba(234, 179, 8, 0.4)' : '1px solid #fde047',
//                                                                 padding: '6px 14px',
//                                                                 borderRadius: '20px',
//                                                                 fontSize: '0.85rem',
//                                                                 fontWeight: '700',
//                                                                 display: 'inline-flex',
//                                                                 alignItems: 'center',
//                                                                 gap: '6px',
//                                                                 boxShadow: '0 1px 3px rgba(146, 64, 14, 0.1)'
//                                                             }}>
//                                                                 🏛️ Selected by Management
//                                                             </span>
//                                                         ) : existingNom ? (
//                                                             <>
//                                                                 <span style={{
//                                                                     background: isDarkTheme ? 'rgba(34, 197, 94, 0.2)' : '#dcfce7',
//                                                                     color: isDarkTheme ? '#4ade80' : '#15803d',
//                                                                     border: isDarkTheme ? '1px solid rgba(74, 222, 128, 0.3)' : '1px solid #86efac',
//                                                                     padding: '5px 12px',
//                                                                     borderRadius: '20px',
//                                                                     fontSize: '0.85rem',
//                                                                     fontWeight: '700',
//                                                                     display: 'inline-flex',
//                                                                     alignItems: 'center',
//                                                                     gap: '4px'
//                                                                 }}>
//                                                                     ✓ Nominated: {existingNom.nomineeName}
//                                                                 </span>
//                                                                 <button
//                                                                     className="classic-btn-nominate"
//                                                                     style={{
//                                                                         background: isDarkTheme ? '#334155' : '#e2e8f0',
//                                                                         color: isDarkTheme ? '#f8fafc' : '#0f172a',
//                                                                         border: isDarkTheme ? '1px solid #475569' : '1px solid #cbd5e1'
//                                                                     }}
//                                                                     onClick={() => handleOpenNominate(cat)}
//                                                                 >
//                                                                     Change Nomination ✏️
//                                                                 </button>
//                                                             </>
//                                                         ) : (
//                                                             <>
//                                                                 <span className="classic-badge-accent">✦ {cat.badge}</span>
//                                                                 <button
//                                                                     className="classic-btn-nominate"
//                                                                     onClick={() => handleOpenNominate(cat)}
//                                                                 >
//                                                                     Nominate ✦
//                                                                 </button>
//                                                             </>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                                 <p className="classic-award-meaning">
//                                                     {cat.description}
//                                                 </p>
//                                                 {cat.isManagementOnly && (
//                                                     <>
//                                                         <div style={{
//                                                             marginTop: '12px',
//                                                             padding: '10px 14px',
//                                                             background: isDarkTheme ? 'rgba(234, 179, 8, 0.1)' : '#fffbeb',
//                                                             borderLeft: '4px solid #d97706',
//                                                             borderRadius: '6px',
//                                                             fontSize: '0.85rem',
//                                                             color: isDarkTheme ? '#fef08a' : '#78350f',
//                                                             fontWeight: '600',
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             gap: '8px'
//                                                         }}>
//                                                             <span style={{ fontSize: '1.1rem' }}>📌</span>
//                                                             <span><strong>Management Selection Note:</strong> This award is evaluated and determined directly by management leadership, based on overall team performance, collaboration, and collective contribution.</span>
//                                                         </div>

//                                                         <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                                             <button
//                                                                 type="button"
//                                                                 onClick={() => {
//                                                                     const elem = document.getElementById('team-structure-section');
//                                                                     if (elem) {
//                                                                         elem.scrollIntoView({ behavior: 'smooth' });
//                                                                     }
//                                                                 }}
//                                                                 style={{
//                                                                     background: isDarkTheme ? 'rgba(59, 130, 246, 0.18)' : '#eff6ff',
//                                                                     color: isDarkTheme ? '#93c5fd' : '#1d4ed8',
//                                                                     border: isDarkTheme ? '1px solid rgba(59, 130, 246, 0.4)' : '1px solid #bfdbfe',
//                                                                     padding: '8px 16px',
//                                                                     borderRadius: '8px',
//                                                                     fontSize: '0.84rem',
//                                                                     fontWeight: '700',
//                                                                     cursor: 'pointer',
//                                                                     display: 'inline-flex',
//                                                                     alignItems: 'center',
//                                                                     gap: '8px',
//                                                                     boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
//                                                                     transition: 'all 0.2s ease'
//                                                                 }}
//                                                             >
//                                                                 <span>🏢 View Teams Eligible For This Award</span>
//                                                                 <span style={{ fontSize: '1rem', fontWeight: '900' }}>↓</span>
//                                                             </button>
//                                                         </div>
//                                                     </>
//                                                 )}
//                                             </div>
//                                         );
//                                     })}
//                                 </div>
//                             </div>
//                         ))}
//                     </section>

//                     {/* SECTION 2: HOW TEAMS & TEAM MEMBERS ARE CATEGORIZED (BELOW) */}
//                     <section id="team-structure-section" className="classic-section" style={{ marginTop: '48px' }}>
//                         <div className="classic-section-header">
//                             <h2 className="classic-section-title" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
//                                 🏢 Team Structure & Member Directory
//                                 <span style={{
//                                     fontSize: '0.78rem',
//                                     background: isDarkTheme ? 'rgba(234, 179, 8, 0.2)' : '#fef3c7',
//                                     color: isDarkTheme ? '#fde047' : '#92400e',
//                                     border: isDarkTheme ? '1px solid rgba(234, 179, 8, 0.4)' : '1px solid #fcd34d',
//                                     padding: '3px 10px',
//                                     borderRadius: '12px',
//                                     fontWeight: '700'
//                                 }}>
//                                     🏆 Eligible Teams for Best Team Award
//                                 </span>
//                             </h2>
//                             <p className="classic-section-subtitle">
//                                 Employees are dynamically categorized into 3 specialized teams based on their assigned departments.These teams are evaluated for the Best Team Award.
//                             </p>
//                         </div>

//                         <div className="classic-teams-list">
//                             {awardTeams.map((team) => (
//                                 <div key={team.team_key} className="classic-team-row">
//                                     <div className="classic-team-meta">
//                                         <div className="classic-team-title-row">
//                                             <span className="classic-team-icon">{team.icon}</span>
//                                             <h3 className="classic-team-name">{team.team_name}</h3>
//                                             <span className="classic-member-count">
//                                                 {team.employees ? team.employees.length : (team.member_count || 0)} Members
//                                             </span>
//                                         </div>

//                                         <div className="classic-dept-criteria">
//                                             <span className="criteria-label">Categorized Depts:</span>
//                                             {(team.departments || []).map((dept, i) => (
//                                                 <span key={i} className="classic-dept-tag">{dept}</span>
//                                             ))}
//                                         </div>
//                                     </div>

//                                     {/* MEMBERS LIST UNDER THIS TEAM */}
//                                     <div className="classic-members-list">
//                                         {team.employees && team.employees.length > 0 ? (
//                                             team.employees.map((emp, i) => (
//                                                 <div key={emp.id || i} className="classic-member-pill">
//                                                     <div className="classic-member-avatar">
//                                                         {(emp.full_name || emp.first_name || 'U').charAt(0).toUpperCase()}
//                                                     </div>
//                                                     <div className="classic-member-info">
//                                                         <span className="classic-member-fullname">
//                                                             {emp.full_name || `${emp.first_name || ''} ${emp.last_name || ''}`.trim()}
//                                                         </span>
//                                                         <span className="classic-member-desig">
//                                                             {emp.designation || 'Team Member'} • <strong style={{ color: isDarkTheme ? '#fef08a' : '#d97706', fontWeight: '700' }}>{emp.department}</strong>
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                             ))
//                                         ) : (
//                                             <div className="classic-empty-members">
//                                                 No members listed under this team criteria in database.
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </section>
//                 </div>
//             )}

//             {/* PAGE 2: AWARD NOMINATIONS GRID ONLY */}
//             {currentPage === 'page-2-categories' && (
//                 <div className="awards-page-container">
//                     <div>
//                         <h2 className="page-header-title">🏆 Award Nominations Cards Grid (Page 2)</h2>
//                         <p className="page-header-sub">
//                             Select any of the 9 awards below to launch a nomination for an outstanding peer or team.
//                         </p>
//                     </div>

//                     {AWARD_GROUPS.map((group) => (
//                         <div key={group.groupNumber} className="award-group-section">
//                             <div className="group-header">
//                                 <div className="group-icon">{group.groupIcon}</div>
//                                 <div>
//                                     <h2 className="group-title">
//                                         {group.groupNumber}) {group.groupTitle} ({group.countLabel})
//                                     </h2>
//                                     <p className="group-desc">{group.groupDesc}</p>
//                                 </div>
//                             </div>

//                             <div className="categories-grid">
//                                 {group.categories.map(cat => {
//                                     const existingNom = nominations.find(n =>
//                                         n.categoryId === cat.id &&
//                                         (n.nominatorName || '').toLowerCase() === currentUserName.toLowerCase()
//                                     );
//                                     return (
//                                         <div key={cat.id} className="category-card">
//                                             <div>
//                                                 <div className="card-top-header">
//                                                     <div className="category-icon-wrapper">{cat.icon}</div>
//                                                     <h3 className="category-name">{cat.name}</h3>
//                                                 </div>
//                                                 <p className="category-desc">{cat.description}</p>
//                                                 {cat.isManagementOnly && (
//                                                     <>
//                                                         <div style={{
//                                                             marginTop: '10px',
//                                                             padding: '8px 12px',
//                                                             background: isDarkTheme ? 'rgba(234, 179, 8, 0.1)' : '#fffbeb',
//                                                             borderLeft: '4px solid #d97706',
//                                                             borderRadius: '6px',
//                                                             fontSize: '0.82rem',
//                                                             color: isDarkTheme ? '#fef08a' : '#78350f',
//                                                             fontWeight: '600'
//                                                         }}>
//                                                             📌 <strong>Management Selection:</strong> Evaluated & decided directly by leadership.
//                                                         </div>
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => {
//                                                                 setCurrentPage('page-1-intro');
//                                                                 setTimeout(() => {
//                                                                     document.getElementById('team-structure-section')?.scrollIntoView({ behavior: 'smooth' });
//                                                                 }, 100);
//                                                             }}
//                                                             style={{
//                                                                 marginTop: '8px',
//                                                                 background: isDarkTheme ? 'rgba(59, 130, 246, 0.15)' : '#eff6ff',
//                                                                 color: isDarkTheme ? '#93c5fd' : '#1d4ed8',
//                                                                 border: isDarkTheme ? '1px solid rgba(59, 130, 246, 0.3)' : '1px solid #bfdbfe',
//                                                                 padding: '6px 12px',
//                                                                 borderRadius: '6px',
//                                                                 fontSize: '0.8rem',
//                                                                 fontWeight: '700',
//                                                                 cursor: 'pointer',
//                                                                 display: 'inline-flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'center',
//                                                                 gap: '6px',
//                                                                 width: '100%'
//                                                             }}
//                                                         >
//                                                             <span>🏢 View Teams & Directory</span>
//                                                             <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>↓</span>
//                                                         </button>
//                                                     </>
//                                                 )}
//                                             </div>

//                                             <div className="category-footer" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '8px' }}>
//                                                 {cat.isManagementOnly ? (
//                                                     <div style={{
//                                                         background: isDarkTheme ? 'rgba(234, 179, 8, 0.18)' : '#fef9c3',
//                                                         color: isDarkTheme ? '#fde047' : '#854d0e',
//                                                         border: isDarkTheme ? '1px solid rgba(234, 179, 8, 0.4)' : '1px solid #fde047',
//                                                         padding: '10px 12px',
//                                                         borderRadius: '8px',
//                                                         fontSize: '0.85rem',
//                                                         fontWeight: '700',
//                                                         textAlign: 'center',
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         justifyContent: 'center',
//                                                         gap: '6px'
//                                                     }}>
//                                                         🏛️ Selected Directly by Management
//                                                     </div>
//                                                 ) : existingNom ? (
//                                                     <div>
//                                                         <div style={{
//                                                             background: isDarkTheme ? 'rgba(34, 197, 94, 0.2)' : '#dcfce7',
//                                                             color: isDarkTheme ? '#4ade80' : '#15803d',
//                                                             border: isDarkTheme ? '1px solid rgba(74, 222, 128, 0.3)' : '1px solid #86efac',
//                                                             padding: '6px 10px',
//                                                             borderRadius: '8px',
//                                                             fontSize: '0.82rem',
//                                                             fontWeight: '700',
//                                                             marginBottom: '8px',
//                                                             textAlign: 'center'
//                                                         }}>
//                                                             ✓ Nominated: {existingNom.nomineeName}
//                                                         </div>
//                                                         <button
//                                                             className="btn-secondary"
//                                                             style={{ width: '100%', padding: '8px 12px', fontSize: '0.85rem' }}
//                                                             onClick={() => handleOpenNominate(cat)}
//                                                         >
//                                                             Change Nomination ✏️
//                                                         </button>
//                                                     </div>
//                                                 ) : (
//                                                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                                                         <span className="award-badge-tag">✦ {cat.badge}</span>
//                                                         <button
//                                                             className="btn-nominate"
//                                                             onClick={() => handleOpenNominate(cat)}
//                                                         >
//                                                             Nominate ✦
//                                                         </button>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>
//                     ))}

//                     <div className="page-bottom-nav">
//                         <button
//                             className="btn-secondary"
//                             onClick={() => setCurrentPage('page-1-intro')}
//                         >
//                             ← Back to Event Intro (Page 1)
//                         </button>
//                         <button
//                             className="btn-primary"
//                             onClick={() => setCurrentPage('page-3-my-submissions')}
//                         >
//                             Next: View My Submissions (Page 3) →
//                         </button>
//                     </div>
//                 </div>
//             )}

//             {/* PAGE 3: MY SUBMISSIONS ONLY */}
//             {currentPage === 'page-3-my-submissions' && (
//                 <div className="awards-page-container">
//                     <h2 className="page-header-title">📜 Nominations Submitted by You (Page 3)</h2>
//                     <p className="page-header-sub">Track the status of all nominations you have submitted for the 3rd Anniversary Gala.</p>

//                     {mySubmissions.length === 0 ? (
//                         <div className="empty-state">
//                             You haven't submitted any nominations yet. Go to Page 1 or Page 2 to select an award and nominate a colleague!
//                         </div>
//                     ) : (
//                         <div className="table-wrapper">
//                             <table className="custom-table">
//                                 <thead>
//                                     <tr>
//                                         <th>Nominee / Team</th>
//                                         <th>Role / Dept</th>
//                                         <th>Award Category</th>
//                                         <th>Submitted Date</th>
//                                         <th>Status</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {mySubmissions.map(item => (
//                                         <tr key={item.id}>
//                                             <td><strong>{item.nomineeName}</strong></td>
//                                             <td>{item.nomineeRole}</td>
//                                             <td>{item.categoryName}</td>
//                                             <td>{item.submittedAt}</td>
//                                             <td>
//                                                 <span className={`status-badge ${item.status.toLowerCase().replace('_', '-')}`}>
//                                                     {item.status.replace('_', ' ')}
//                                                 </span>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}

//                     <div className="page-bottom-nav">
//                         <button
//                             className="btn-secondary"
//                             onClick={() => setCurrentPage('page-2-categories')}
//                         >
//                             ← Back to Award Grid (Page 2)
//                         </button>
//                         <button
//                             className="btn-primary"
//                             onClick={() => setCurrentPage(pagesList[currentPageIndex + 1]?.id || 'page-6-hall-of-fame')}
//                         >
//                             Next Page →
//                         </button>
//                     </div>
//                 </div>
//             )}

//             {/* PAGE 4: MANAGER TEAM ENDORSEMENTS ONLY */}
//             {currentPage === 'page-4-endorsements' && (role === 'Manager' || role === 'Management') && (
//                 <div className="awards-page-container">
//                     <h2 className="page-header-title">👥 Team Nominations for Manager Endorsement (Page 4)</h2>
//                     <p className="page-header-sub">Review employee nominations submitted by team members and attach manager recommendations.</p>

//                     {pendingEndorsements.length === 0 ? (
//                         <div className="empty-state">
//                             No pending nominations awaiting manager endorsement at this time.
//                         </div>
//                     ) : (
//                         <div className="table-wrapper">
//                             <table className="custom-table">
//                                 <thead>
//                                     <tr>
//                                         <th>Nominee / Team</th>
//                                         <th>Award Category</th>
//                                         <th>Nominator</th>
//                                         <th>Reason & Key Achievements</th>
//                                         <th>Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {pendingEndorsements.map(item => (
//                                         <tr key={item.id}>
//                                             <td><strong>{item.nomineeName}</strong> ({item.nomineeRole})</td>
//                                             <td>{item.categoryName}</td>
//                                             <td>{item.nominatorName} ({item.nominatorRole})</td>
//                                             <td style={{ maxWidth: '320px' }}>{item.reason}</td>
//                                             <td>
//                                                 <button
//                                                     className="btn-primary"
//                                                     style={{ padding: '8px 14px', fontSize: '0.82rem' }}
//                                                     onClick={() => setEndorseModalItem(item)}
//                                                 >
//                                                     Endorse & Recommend
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}

//                     <div className="page-bottom-nav">
//                         <button
//                             className="btn-secondary"
//                             onClick={() => setCurrentPage('page-3-my-submissions')}
//                         >
//                             ← Back to My Submissions (Page 3)
//                         </button>
//                         <button
//                             className="btn-primary"
//                             onClick={() => setCurrentPage(pagesList[currentPageIndex + 1]?.id || 'page-6-hall-of-fame')}
//                         >
//                             Next Page →
//                         </button>
//                     </div>
//                 </div>
//             )}

//             {/* PAGE 5: MANAGEMENT ADMIN PANEL & ANALYTICS */}
//             {currentPage === 'page-5-admin' && role === 'Management' && (
//                 <div className="awards-page-container">
//                     <h2 className="page-header-title">📊 3rd Anniversary Management Analytics & Winner Selection (Page 5)</h2>
//                     <p className="page-header-sub">Live database analytics from elmsdb, candidate nomination metrics, and official ceremony committee control panel.</p>

//                     {/* TOP STATS ANALYTICS CARDS */}
//                     <div className="award-analytics-stats-grid" style={{
//                         display: 'grid',
//                         gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
//                         gap: '16px',
//                         marginBottom: '28px'
//                     }}>
//                         <div className="analytics-stat-card" style={{
//                             background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
//                             border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
//                             borderRadius: '14px',
//                             padding: '20px',
//                             boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
//                         }}>
//                             <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                                 Total Nominations
//                             </div>
//                             <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#f59e0b', marginTop: '6px' }}>
//                                 {analyticsStats.total}
//                             </div>
//                             <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
//                                 Saved in elmsdb database
//                             </div>
//                         </div>

//                         <div className="analytics-stat-card" style={{
//                             background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
//                             border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
//                             borderRadius: '14px',
//                             padding: '20px',
//                             boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
//                         }}>
//                             <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                                 Pending Review
//                             </div>
//                             <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#3b82f6', marginTop: '6px' }}>
//                                 {analyticsStats.pending}
//                             </div>
//                             <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
//                                 Awaiting manager endorsement
//                             </div>
//                         </div>

//                         <div className="analytics-stat-card" style={{
//                             background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
//                             border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
//                             borderRadius: '14px',
//                             padding: '20px',
//                             boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
//                         }}>
//                             <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                                 Manager Endorsed
//                             </div>
//                             <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#10b981', marginTop: '6px' }}>
//                                 {analyticsStats.endorsed}
//                             </div>
//                             <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
//                                 Recommended by leadership
//                             </div>
//                         </div>

//                         <div className="analytics-stat-card" style={{
//                             background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
//                             border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
//                             borderRadius: '14px',
//                             padding: '20px',
//                             boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
//                         }}>
//                             <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                                 Winners Honored
//                             </div>
//                             <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#ec4899', marginTop: '6px' }}>
//                                 {analyticsStats.winners}
//                             </div>
//                             <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
//                                 Declared for Gala Ceremony
//                             </div>
//                         </div>
//                     </div>

//                     {/* TWO-COLUMN ANALYTICS DETAILED BREAKDOWN */}
//                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px', marginBottom: '32px' }}>
//                         {/* COLUMN 1: CATEGORY BREAKDOWN */}
//                         <div style={{
//                             background: isDarkTheme ? '#1e293b' : '#ffffff',
//                             border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
//                             borderRadius: '14px',
//                             padding: '20px'
//                         }}>
//                             <h3 style={{ fontSize: '1.1rem', fontWeight: '800', color: isDarkTheme ? '#f8fafc' : '#0f172a', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                 <span>🏆</span> Submissions by Award Category
//                             </h3>
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                                 {analyticsStats.categoryBreakdown.map(cat => {
//                                     const pct = analyticsStats.total > 0 ? Math.round((cat.count / analyticsStats.total) * 100) : 0;
//                                     return (
//                                         <div key={cat.id}>
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.88rem', fontWeight: '600', color: isDarkTheme ? '#e2e8f0' : '#334155', marginBottom: '4px' }}>
//                                                 <span>{cat.icon} {cat.name}</span>
//                                                 <span>{cat.count} nomination{cat.count !== 1 ? 's' : ''} ({pct}%)</span>
//                                             </div>
//                                             <div style={{ height: '8px', background: isDarkTheme ? '#0f172a' : '#f1f5f9', borderRadius: '4px', overflow: 'hidden' }}>
//                                                 <div style={{
//                                                     height: '100%',
//                                                     width: `${pct}%`,
//                                                     background: 'linear-gradient(90deg, #f59e0b, #d97706)',
//                                                     borderRadius: '4px',
//                                                     transition: 'width 0.4s ease'
//                                                 }}></div>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>

//                         {/* COLUMN 2: TOP NOMINATED EMPLOYEES LEADERBOARD */}
//                         <div style={{
//                             background: isDarkTheme ? '#1e293b' : '#ffffff',
//                             border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
//                             borderRadius: '14px',
//                             padding: '20px'
//                         }}>
//                             <h3 style={{ fontSize: '1.1rem', fontWeight: '800', color: isDarkTheme ? '#f8fafc' : '#0f172a', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                 <span>🌟</span> Top Nominated Candidates
//                             </h3>
//                             {analyticsStats.topNominees.length === 0 ? (
//                                 <div style={{ color: isDarkTheme ? '#94a3b8' : '#64748b', fontSize: '0.9rem', textAlign: 'center', padding: '20px' }}>
//                                     No employee nominations recorded yet.
//                                 </div>
//                             ) : (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                                     {analyticsStats.topNominees.map((nom, i) => (
//                                         <div key={i} style={{
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'space-between',
//                                             padding: '10px 14px',
//                                             background: isDarkTheme ? '#0f172a' : '#f8fafc',
//                                             borderRadius: '10px',
//                                             border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0'
//                                         }}>
//                                             <div>
//                                                 <div style={{ fontWeight: '700', fontSize: '0.95rem', color: isDarkTheme ? '#f8fafc' : '#0f172a' }}>
//                                                     {i + 1}. {nom.name}
//                                                 </div>
//                                                 <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#94a3b8' : '#64748b' }}>
//                                                     {nom.role}
//                                                 </div>
//                                             </div>
//                                             <div style={{ textAlign: 'right' }}>
//                                                 <span style={{
//                                                     background: isDarkTheme ? 'rgba(245, 158, 11, 0.2)' : '#fef3c7',
//                                                     color: isDarkTheme ? '#fbbf24' : '#d97706',
//                                                     padding: '4px 10px',
//                                                     borderRadius: '20px',
//                                                     fontWeight: '800',
//                                                     fontSize: '0.85rem'
//                                                 }}>
//                                                     {nom.count} Nomination{nom.count !== 1 ? 's' : ''}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     <h3 style={{ fontSize: '1.2rem', fontWeight: '800', color: isDarkTheme ? '#f8fafc' : '#0f172a', marginBottom: '14px' }}>
//                         📋 All Nominees Table & Winner Declaration
//                     </h3>

//                     <div className="table-wrapper">
//                         <table className="custom-table">
//                             <thead>
//                                 <tr>
//                                     <th>Nominee / Team</th>
//                                     <th>Award Category</th>
//                                     <th>Nominator</th>
//                                     <th>Status</th>
//                                     <th>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {nominations.map(item => (
//                                     <tr key={item.id}>
//                                         <td><strong>{item.nomineeName}</strong> ({item.nomineeRole})</td>
//                                         <td>{item.categoryName}</td>
//                                         <td>{item.nominatorName}</td>
//                                         <td>
//                                             <span className={`status-badge ${item.status.toLowerCase().replace('_', '-')}`}>
//                                                 {item.status.replace('_', ' ')}
//                                             </span>
//                                         </td>
//                                         <td>
//                                             {item.status !== 'WINNER_DECLARED' ? (
//                                                 <button
//                                                     className="btn-nominate"
//                                                     onClick={() => handleDeclareWinner(item)}
//                                                 >
//                                                     👑 Declare Winner
//                                                 </button>
//                                             ) : (
//                                                 <span style={{ color: '#4ade80', fontWeight: 'bold' }}>🎉 Honored Winner</span>
//                                             )}
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="page-bottom-nav">
//                         <button
//                             className="btn-secondary"
//                             onClick={() => setCurrentPage('page-4-endorsements')}
//                         >
//                             ← Previous Page
//                         </button>
//                         <button
//                             className="btn-primary"
//                             onClick={() => setCurrentPage('page-6-hall-of-fame')}
//                         >
//                             Next: Wall of Fame (Page 6) →
//                         </button>
//                     </div>
//                 </div>
//             )}

//             {/* PAGE 6: WALL OF FAME ONLY */}
//             {currentPage === 'page-6-hall-of-fame' && (
//                 <div className="awards-page-container">
//                     <h2 className="page-header-title">🌟 Wall of Fame - 3rd Anniversary Honorees</h2>
//                     <p className="page-header-sub">Celebrating official winners and honorees of the Genesis Tech Engineers Award Ceremony.</p>

//                     <div className="hall-grid">
//                         {hallOfFame.map(item => (
//                             <div key={item.id} className="hall-card">
//                                 <div className="hall-trophy-icon">{item.icon}</div>
//                                 <h3 className="hall-winner-name">{item.winnerName}</h3>
//                                 <div className="hall-winner-role">{item.role}</div>
//                                 <span className="hall-award-title">{item.awardTitle}</span>
//                                 <p className="hall-citation">"{item.citation}"</p>
//                             </div>
//                         ))}
//                     </div>

//                     <div className="page-bottom-nav">
//                         <button
//                             className="btn-secondary"
//                             onClick={() => setCurrentPage(pagesList[currentPageIndex - 1]?.id || 'page-1-intro')}
//                         >
//                             ← Previous Page
//                         </button>
//                         <button
//                             className="btn-primary"
//                             onClick={() => setCurrentPage('page-1-intro')}
//                         >
//                             Back to Event Intro (Page 1) ↺
//                         </button>
//                     </div>
//                 </div>
//             )}

//             {/* MODAL: SUBMIT NOMINATION (PORTAL TO BODY FOR TRUE VIEWPORT POPUP) */}
//             {showNominateModal && ReactDOM.createPortal(
//                 <div className={`award-modal-overlay ${isDarkTheme ? 'dark-theme-modal' : 'light-theme-modal'}`}>
//                     <div className="award-modal-card">
//                         <div className="modal-header">
//                             <h3 className="modal-title">
//                                 <span>{selectedCategory?.icon || '🏆'}</span> Nominate for {selectedCategory?.name}
//                             </h3>
//                             <button
//                                 className="btn-close-modal"
//                                 onClick={() => setShowNominateModal(false)}
//                             >
//                                 ✕
//                             </button>
//                         </div>
//                         <form onSubmit={handleSubmitNomination}>
//                             <div className="form-group">
//                                 <label className="form-label" style={{ color: isDarkTheme ? '#fef08a' : '#b45309', fontWeight: '700', marginBottom: '8px', display: 'block' }}>
//                                     Award Category Selected
//                                 </label>
//                                 <div
//                                     className="selected-category-read-only"
//                                     style={{
//                                         padding: '12px 16px',
//                                         borderRadius: '8px',
//                                         background: isDarkTheme ? 'rgba(245, 158, 11, 0.12)' : '#fef3c7',
//                                         border: isDarkTheme ? '1px solid rgba(245, 158, 11, 0.3)' : '1px solid #fde68a',
//                                         color: isDarkTheme ? '#fbbf24' : '#92400e',
//                                         fontWeight: '700',
//                                         fontSize: '1.02rem',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '10px'
//                                     }}
//                                 >
//                                     <span style={{ fontSize: '1.2rem' }}>{selectedCategory?.icon || '🏆'}</span>
//                                     <span>{selectedCategory?.name || 'Employee of the Year'}</span>
//                                 </div>
//                             </div>

//                             {/* QUESTION 1 */}
//                             <div className="form-group" style={{ marginTop: '22px' }}>
//                                 <label className="form-label" style={{ fontSize: '1.05rem', fontWeight: '800', color: isDarkTheme ? '#ffffff' : '#0f172a', marginBottom: '6px' }}>
//                                     1) Who do you think deserves this award? <span style={{ color: '#ef4444' }}>*</span>
//                                 </label>
//                                 <div style={{ fontSize: '0.88rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginBottom: '10px' }}>
//                                     Type name or select an employee from the list below:
//                                 </div>

//                                 {/* INDIVIDUAL EMPLOYEE AWARDS: SEARCHABLE EMPLOYEE DROPDOWN CONTAINER */}
//                                 <div style={{
//                                     background: isDarkTheme ? '#0f172a' : '#ffffff',
//                                     border: isDarkTheme ? '2px solid #f59e0b' : '2px solid #d97706',
//                                     borderRadius: '14px',
//                                     padding: '12px',
//                                     boxShadow: '0 4px 15px rgba(0,0,0,0.15)'
//                                 }}>
//                                     {/* Typing Search Field */}
//                                     <div style={{ position: 'relative', marginBottom: '10px' }}>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder="🔍 Type employee name, department, or role to search..."
//                                             value={empSearchQuery}
//                                             onChange={e => setEmpSearchQuery(e.target.value)}
//                                             style={{
//                                                 fontSize: '0.95rem',
//                                                 padding: '11px 36px 11px 14px',
//                                                 borderRadius: '10px',
//                                                 background: isDarkTheme ? '#1e293b' : '#f8fafc',
//                                                 color: isDarkTheme ? '#f8fafc' : '#0f172a',
//                                                 border: isDarkTheme ? '1px solid #475569' : '1px solid #cbd5e1',
//                                                 fontWeight: '600',
//                                                 outline: 'none',
//                                                 width: '100%'
//                                             }}
//                                         />
//                                         {empSearchQuery && (
//                                             <button
//                                                 type="button"
//                                                 onClick={() => setEmpSearchQuery('')}
//                                                 style={{
//                                                     position: 'absolute',
//                                                     right: '12px',
//                                                     top: '50%',
//                                                     transform: 'translateY(-50%)',
//                                                     background: 'none',
//                                                     border: 'none',
//                                                     color: isDarkTheme ? '#94a3b8' : '#64748b',
//                                                     cursor: 'pointer',
//                                                     fontSize: '1rem'
//                                                 }}
//                                             >
//                                                 ✕
//                                             </button>
//                                         )}
//                                     </div>

//                                     {/* Selected Nominee Banner (inside container) */}
//                                     {formData.nomineeName && (
//                                         <div style={{
//                                             marginBottom: '10px',
//                                             padding: '10px 14px',
//                                             borderRadius: '8px',
//                                             background: isDarkTheme ? 'rgba(34, 197, 94, 0.15)' : '#dcfce7',
//                                             border: isDarkTheme ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid #86efac',
//                                             color: isDarkTheme ? '#4ade80' : '#15803d',
//                                             fontWeight: '700',
//                                             fontSize: '0.92rem',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'space-between'
//                                         }}>
//                                             <span>✓ Selected: <strong>{formData.nomineeName}</strong> {formData.nomineeRole && `(${formData.nomineeRole})`}</span>
//                                             <button
//                                                 type="button"
//                                                 onClick={() => setFormData({ ...formData, nomineeName: '', nomineeRole: '' })}
//                                                 style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontWeight: '700', textDecoration: 'underline' }}
//                                             >
//                                                 Clear
//                                             </button>
//                                         </div>
//                                     )}

//                                     {/* Direct Scrollable Employee Options List */}
//                                     <div style={{
//                                         maxHeight: '195px',
//                                         overflowY: 'auto',
//                                         display: 'flex',
//                                         flexDirection: 'column',
//                                         gap: '5px',
//                                         paddingRight: '2px'
//                                     }}>
//                                         {filteredEmpOptions.length === 0 ? (
//                                             <div style={{ padding: '16px', textAlign: 'center', color: isDarkTheme ? '#94a3b8' : '#64748b', fontSize: '0.9rem' }}>
//                                                 No matching employees found for "{empSearchQuery}"
//                                             </div>
//                                         ) : (
//                                             filteredEmpOptions.map((emp, i) => {
//                                                 const isSelected = formData.nomineeName === emp.name;
//                                                 return (
//                                                     <div
//                                                         key={i}
//                                                         onClick={() => {
//                                                             setFormData({
//                                                                 ...formData,
//                                                                 nomineeName: emp.name,
//                                                                 nomineeRole: `${emp.role}${emp.dept ? ' (' + emp.dept + ')' : ''}`
//                                                             });
//                                                         }}
//                                                         style={{
//                                                             padding: '10px 14px',
//                                                             borderRadius: '8px',
//                                                             cursor: 'pointer',
//                                                             background: isSelected
//                                                                 ? (isDarkTheme ? 'rgba(245, 158, 11, 0.25)' : '#fef3c7')
//                                                                 : (isDarkTheme ? '#1e293b' : '#ffffff'),
//                                                             border: isSelected
//                                                                 ? (isDarkTheme ? '1px solid #f59e0b' : '1px solid #d97706')
//                                                                 : (isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0'),
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             justifyContent: 'space-between',
//                                                             transition: 'all 0.15s ease'
//                                                         }}
//                                                         onMouseEnter={(e) => {
//                                                             if (!isSelected) {
//                                                                 e.currentTarget.style.background = isDarkTheme ? 'rgba(255, 255, 255, 0.05)' : '#f1f5f9';
//                                                             }
//                                                         }}
//                                                         onMouseLeave={(e) => {
//                                                             if (!isSelected) {
//                                                                 e.currentTarget.style.background = isDarkTheme ? '#1e293b' : '#ffffff';
//                                                             }
//                                                         }}
//                                                     >
//                                                         <div>
//                                                             <div style={{ fontWeight: '700', fontSize: '0.95rem', color: isDarkTheme ? '#f8fafc' : '#0f172a' }}>
//                                                                 {emp.name}
//                                                             </div>
//                                                             <div style={{ fontSize: '0.82rem', color: isDarkTheme ? '#cbd5e1' : '#64748b', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
//                                                                 {emp.dept && (
//                                                                     <span style={{
//                                                                         background: isDarkTheme ? 'rgba(245, 158, 11, 0.15)' : '#fffbeb',
//                                                                         color: isDarkTheme ? '#fbbf24' : '#d97706',
//                                                                         border: isDarkTheme ? '1px solid rgba(245, 158, 11, 0.3)' : '1px solid #fde68a',
//                                                                         padding: '1px 6px',
//                                                                         borderRadius: '4px',
//                                                                         fontWeight: '600'
//                                                                     }}>
//                                                                         {emp.dept}
//                                                                     </span>
//                                                                 )}
//                                                                 <span>{emp.role}</span>
//                                                             </div>
//                                                         </div>
//                                                         {isSelected ? (
//                                                             <span style={{ color: isDarkTheme ? '#fbbf24' : '#d97706', fontWeight: '800', fontSize: '0.98rem' }}>✓ Selected</span>
//                                                         ) : (
//                                                             <span style={{ fontSize: '0.8rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '600' }}>Select →</span>
//                                                         )}
//                                                     </div>
//                                                 );
//                                             })
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* QUESTION 2 */}
//                             <div className="form-group" style={{ marginTop: '22px' }}>
//                                 <label className="form-label" style={{ fontSize: '1.05rem', fontWeight: '800', color: isDarkTheme ? '#ffffff' : '#0f172a', marginBottom: '6px' }}>
//                                     2) Why are you nominating this person?
//                                 </label>
//                                 <div style={{ fontSize: '0.88rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginBottom: '8px' }}>
//                                     Write your detailed answer explaining their contributions:
//                                 </div>
//                                 <textarea
//                                     className="form-textarea"
//                                     placeholder="Write your answer explaining why this person deserves this award..."
//                                     value={formData.reason}
//                                     onChange={e => setFormData({ ...formData, reason: e.target.value })}
//                                     required
//                                     rows={5}
//                                     style={{ fontSize: '0.95rem', minHeight: '140px' }}
//                                 />
//                             </div>

//                             <div className="modal-actions">
//                                 <button
//                                     type="button"
//                                     className="btn-secondary"
//                                     onClick={() => setShowNominateModal(false)}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button type="submit" className="btn-primary">
//                                     Submit Nomination 🚀
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {/* MODAL: MANAGER ENDORSEMENT */}
//             {endorseModalItem && ReactDOM.createPortal(
//                 <div className={`award-modal-overlay ${isDarkTheme ? 'dark-theme-modal' : 'light-theme-modal'}`}>
//                     <div className="award-modal-card">
//                         <div className="modal-header">
//                             <h3 className="modal-title">
//                                 👥 Endorse Nomination for {endorseModalItem.nomineeName}
//                             </h3>
//                             <button className="btn-close-modal" onClick={() => setEndorseModalItem(null)}>✕</button>
//                         </div>
//                         <div>
//                             <p style={{ color: '#cbd5e1', fontSize: '0.9rem', marginBottom: '14px' }}>
//                                 <strong>Category:</strong> {endorseModalItem.categoryName}<br />
//                                 <strong>Nominated By:</strong> {endorseModalItem.nominatorName}<br />
//                                 <strong>Original Contribution Reason:</strong> "{endorseModalItem.reason}"
//                             </p>
//                             <div className="form-group">
//                                 <label className="form-label">Manager Endorsement Note / Recommendation</label>
//                                 <textarea
//                                     className="form-textarea"
//                                     placeholder="Add manager endorsement note for the committee..."
//                                     value={endorsementComment}
//                                     onChange={e => setEndorsementComment(e.target.value)}
//                                 />
//                             </div>
//                             <div className="modal-actions">
//                                 <button className="btn-secondary" onClick={() => setEndorseModalItem(null)}>Cancel</button>
//                                 <button
//                                     className="btn-primary"
//                                     onClick={() => handleEndorseNomination(endorseModalItem.id)}
//                                 >
//                                     Endorse Nomination ✅
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}
//         </div>
//     );
// };

// export default AwardNominations;





























import React, { useState, useEffect, useRef, useMemo } from 'react';
import ReactDOM from 'react-dom';
import './AwardNominations.css';

// Exact 9 award categories structured by 3 sections as specified by user
const AWARD_GROUPS = [
    {
        groupNumber: '1',
        groupTitle: 'Overall Company Awards',
        groupIcon: '👑',
        countLabel: '4 Awards',
        groupDesc: 'Highest organizational honors celebrating year-round individual leadership, customer impact, and exceptional dedication.',
        categories: [
            {
                id: 'emp-of-year',
                name: 'Employee of the Year',
                icon: '🌟',
                badge: 'Grand Honor',
                description: "Recognizes an employee who has consistently demonstrated exceptional performance, dedication, and impact throughout the year. This award celebrates outstanding contributions that have significantly advanced the company's goals and values."
            },
            {
                id: 'leadership-excellence',
                name: 'Leadership Excellence Award',
                icon: '🏆',
                badge: 'Leadership Honor',
                description: 'Honors an individual who inspires, empowers, and leads others to achieve outstanding results. This award recognizes exemplary leadership, decision-making, and commitment to developing people and fostering a positive work culture.'
            },
            {
                id: 'rising-star',
                name: 'Rising Star Award',
                icon: '🚀',
                badge: 'Emerging Talent',
                description: 'Recognizes a high-potential employee who has shown remarkable growth, initiative, and achievement in a short period. This award celebrates emerging talent and future leaders who make a meaningful impact on the organization.'
            },
            {
                id: 'customer-excellence-champion',
                name: 'Customer Excellence Champion Award',
                icon: '🤝',
                badge: 'Client Impact',
                description: 'Honors an employee who consistently goes above and beyond to deliver exceptional customer experiences. This award recognizes a strong commitment to understanding customer needs, building trust, and driving customer satisfaction.'
            }
        ]
    },
    {
        groupNumber: '2',
        groupTitle: 'Team-Wise Awards',
        groupIcon: '💎',
        countLabel: '4 Awards',
        groupDesc: 'Honoring departmental excellence, team collaboration, quality standards, and mentorship.',
        categories: [
            {
                id: 'team-player',
                name: 'Team Player Award',
                icon: '❤️',
                badge: 'Collaboration',
                description: 'Recognizes an employee who consistently collaborates effectively and supports colleagues to achieve shared goals. This award celebrates individuals who foster teamwork, positivity, and a spirit of cooperation.'
            },
            {
                id: 'quality-champion',
                name: 'Quality Champion Award',
                icon: '🎯',
                badge: 'Quality & Precision',
                description: 'Honors an employee who demonstrates an unwavering commitment to quality and continuous improvement. This award recognizes those who maintain high standards and help ensure excellence in every aspect of their work.'
            },
            {
                id: 'ownership-excellence',
                name: 'Ownership Excellence Award',
                icon: '⚡',
                badge: 'Accountability',
                description: 'Recognizes an employee who takes full accountability for their responsibilities and proactively drives results. This award celebrates individuals who demonstrate initiative, reliability, and a strong sense of ownership.'
            },
            {
                id: 'mentor-of-year',
                name: 'Mentor of the Year Award',
                icon: '💡',
                badge: 'Mentorship',
                description: 'Honors an employee who has made a significant impact through coaching, guiding, and developing others. This award recognizes dedication to sharing knowledge, supporting growth, and helping colleagues achieve success.'
            }
        ]
    },
    {
        groupNumber: '3',
        groupTitle: 'Best Team Award',
        groupIcon: '🏆',
        countLabel: '1 Award (Management Selection)',
        groupDesc: 'Recognizes overall team achievements, evaluated and selected directly by Management leadership.',
        categories: [
            {
                id: 'team-excellence',
                name: 'Team Excellence Award',
                icon: '🎖️',
                badge: 'Management Selection',
                isManagementOnly: true,
                description: 'Recognizes a team that has demonstrated outstanding collaboration, innovation, and performance in achieving its objectives. This award celebrates collective success, cross-functional teamwork, and the ability to deliver exceptional results together.'
            }
        ]
    }
];

// Flat array of all categories
const ALL_CATEGORIES = AWARD_GROUPS.flatMap(g => g.categories);
const GROUP_2_CATEGORY_IDS = new Set(AWARD_GROUPS.find(g => g.groupNumber === '2')?.categories.map(c => c.id) || []);

const DEFAULT_HALL_OF_FAME = [
    {
        id: 'hof-1',
        winnerName: 'Aarav Sharma',
        role: 'Senior Fullstack Lead',
        awardTitle: 'Employee of the Year 2025',
        icon: '🌟',
        citation: 'Consistently demonstrated exceptional performance, dedication, and measurable impact.'
    },
    {
        id: 'hof-2',
        winnerName: 'Priya Patel',
        role: 'Project Lead',
        awardTitle: 'Leadership Excellence Award 2025',
        icon: '🏆',
        citation: 'Empowered project teams through exceptional leadership and strategic execution.'
    }
];

const AwardNominations = ({ userData, role = 'Employee', theme: themeProp }) => {
    const currentUserName = userData ? `${userData.firstName || ''} ${userData.lastName || ''}`.trim() || 'Employee User' : 'Employee User';

    // Dynamic theme state detection (Dark / Light)
    const [isDarkTheme, setIsDarkTheme] = useState(() => {
        if (themeProp === 'dark') return true;
        if (themeProp === 'light') return false;
        const dataTheme = document.documentElement.getAttribute('data-theme');
        if (dataTheme === 'dark') return true;
        if (dataTheme === 'light') return false;
        const bodyClass = document.body.className || '';
        if (bodyClass.includes('dark')) return true;
        const localTheme = localStorage.getItem('theme') || localStorage.getItem('dashboard-theme');
        return localTheme === 'dark';
    });

    useEffect(() => {
        const checkTheme = () => {
            if (themeProp === 'dark') { setIsDarkTheme(true); return; }
            if (themeProp === 'light') { setIsDarkTheme(false); return; }
            const dataTheme = document.documentElement.getAttribute('data-theme');
            if (dataTheme === 'dark') { setIsDarkTheme(true); return; }
            if (dataTheme === 'light') { setIsDarkTheme(false); return; }
            const bodyClass = document.body.className || '';
            const localTheme = localStorage.getItem('theme') || localStorage.getItem('dashboard-theme');
            const dark = bodyClass.includes('dark') || localTheme === 'dark';
            setIsDarkTheme(dark);
        };

        checkTheme();
        const observer = new MutationObserver(checkTheme);
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme', 'class'] });
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        return () => observer.disconnect();
    }, [themeProp]);

    // Multi-page navigation state: 'page-1-intro', 'page-2-categories', 'page-3-my-submissions', 'page-4-endorsements', 'page-5-admin', 'page-6-hall-of-fame'
    const [currentPage, setCurrentPage] = useState('page-1-intro');

    // Database employee list
    const [dbEmployees, setDbEmployees] = useState([]);

    // Teams state for 3 featured teams
    const [awardTeams, setAwardTeams] = useState([
        {
            team_key: 'software_team',
            team_name: 'Software Team',
            icon: '💻',
            departments: ['LTDM PC', 'GTE-Technology Operations'],
            employees: []
        },
        {
            team_key: 'bim_team',
            team_name: 'BIM Team',
            icon: '🏗️',
            departments: ['FSPLO', 'DDI', 'DMS', 'FI-IE'],
            employees: []
        },
        {
            team_key: 'fi_design_team',
            team_name: 'FI Design Team',
            icon: '🎨',
            departments: ['FI Design', 'LTO'],
            employees: []
        }
    ]);

    // Nominations state
    const [nominations, setNominations] = useState(() => {
        const saved = localStorage.getItem('gte_3rd_anniversary_nominations');
        return saved ? JSON.parse(saved) : [
            {
                id: 'nom-301',
                nomineeName: 'Priya Patel',
                nomineeRole: 'Senior Analyst',
                categoryId: 'emp-of-year',
                categoryName: 'Employee of the Year',
                nominatorName: 'Rohan Mehta',
                nominatorRole: 'Manager',
                reason: 'Consistently exceeded performance metrics and demonstrated extraordinary commitment to corporate growth.',
                status: 'PENDING_REVIEW',
                submittedAt: '2026-09-02'
            }
        ];
    });

    const [hallOfFame, setHallOfFame] = useState(() => {
        const saved = localStorage.getItem('gte_3rd_anniversary_hof');
        return saved ? JSON.parse(saved) : DEFAULT_HALL_OF_FAME;
    });

    // Modal state for nominating
    const [showNominateModal, setShowNominateModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(ALL_CATEGORIES[0]);
    const [empSearchQuery, setEmpSearchQuery] = useState('');
    const [isEmpDropdownOpen, setIsEmpDropdownOpen] = useState(false);
    const empDropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (empDropdownRef.current && !empDropdownRef.current.contains(e.target)) {
                setIsEmpDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const [formData, setFormData] = useState({
        nomineeName: '',
        nomineeRole: '',
        categoryId: ALL_CATEGORIES[0].id,
        reason: ''
    });

    // Manager endorsement modal state
    const [endorseModalItem, setEndorseModalItem] = useState(null);
    const [endorsementComment, setEndorsementComment] = useState('');

    // Logged in user identifiers for self-nomination prevention
    const loggedInUserIdentifiers = React.useMemo(() => {
        const names = new Set();
        const ids = new Set();

        const processUserObj = (obj) => {
            if (!obj || typeof obj !== 'object') return;
            if (obj.id) ids.add(String(obj.id).toLowerCase().trim());
            if (obj.EmpId) ids.add(String(obj.EmpId).toLowerCase().trim());
            if (obj.emp_id) ids.add(String(obj.emp_id).toLowerCase().trim());

            const fn = (obj.firstName || obj.FirstName || '').trim();
            const ln = (obj.lastName || obj.LastName || '').trim();
            const fullName = (obj.fullName || obj.name || '').trim();

            if (fn && ln) names.add(`${fn} ${ln}`.toLowerCase());
            if (fullName) names.add(fullName.toLowerCase());
            if (fn) names.add(fn.toLowerCase());
        };

        processUserObj(userData);

        try {
            const localUser = JSON.parse(localStorage.getItem('userData') || localStorage.getItem('user') || '{}');
            processUserObj(localUser);
        } catch (e) { }

        if (currentUserName && currentUserName !== 'Employee User') {
            names.add(currentUserName.trim().toLowerCase());
        }

        return { names, ids };
    }, [userData, currentUserName]);

    // Master employee options list combining database employees and team rosters
    const allEmployeeOptions = React.useMemo(() => {
        const map = new Map();
        // Add from dbEmployees
        dbEmployees.forEach(emp => {
            const name = emp.full_name || `${emp.FirstName || ''} ${emp.LastName || ''}`.trim();
            if (name && !map.has(name)) {
                map.set(name, {
                    id: emp.id || emp.EmpId || '',
                    name,
                    role: emp.Designation || emp.designation || emp.Department || emp.department || 'Team Member',
                    dept: emp.Department || emp.department || ''
                });
            }
        });
        // Add from awardTeams
        awardTeams.forEach(t => {
            (t.employees || []).forEach(emp => {
                const name = emp.full_name || `${emp.first_name || ''} ${emp.last_name || ''}`.trim();
                if (name && !map.has(name)) {
                    map.set(name, {
                        id: emp.id || emp.EmpId || '',
                        name,
                        role: emp.designation || t.team_name || 'Team Member',
                        dept: emp.department || ''
                    });
                }
            });
        });
        // Fallback default list if database response is loading/empty
        if (map.size === 0) {
            [
                { id: '', name: 'Aarav Sharma', role: 'Senior Lead', dept: 'Software Team' },
                { id: '', name: 'Priya Patel', role: 'Project Analyst', dept: 'BIM Team' },
                { id: '', name: 'Rohan Mehta', role: 'Design Lead', dept: 'FI Design Team' },
                { id: '', name: 'Vikram Singh', role: 'BIM Specialist', dept: 'BIM Team' },
                { id: '', name: 'Ananya Roy', role: 'Tech Operations', dept: 'Software Team' }
            ].forEach(emp => map.set(emp.name, emp));
        }

        let list = Array.from(map.values());

        // Exclude specified people from every award nomination employee list:
        // 1) Ankur Patil, 2) Shubham Patil, 3) Neeta Sangvikar, 4) Ganesh Gorakh Chavan, 5) Rakesh Sharma (specifically Rakesh Sharma, leaving Rakesh GS), 6) Sandeep Potti, 7) Aron Fisher, 8) Sunita Shantaram Patil, 9) Shantaram Patil
        list = list.filter(emp => {
            const nameLower = (emp.name || '').trim().toLowerCase();
            const isExcluded =
                nameLower.includes('ankur') ||
                nameLower.includes('shubham') ||
                nameLower.includes('neeta') ||
                nameLower.includes('ganesh') ||
                (nameLower.includes('rakesh') && nameLower.includes('sharma')) ||
                nameLower.includes('sandeep') ||
                nameLower.includes('potti') ||
                nameLower.includes('aron') ||
                nameLower.includes('fisher') ||
                nameLower.includes('sunita') ||
                nameLower.includes('shantaram');
            return !isExcluded;
        });

        // Filter out logged in user to prevent self nomination
        list = list.filter(emp => {
            const empNameLower = emp.name.trim().toLowerCase();
            const empIdLower = emp.id ? String(emp.id).toLowerCase().trim() : '';

            // 1. Check ID match
            if (empIdLower && loggedInUserIdentifiers.ids.has(empIdLower)) {
                return false;
            }

            // 2. Check exact name match in loggedInUserIdentifiers.names
            if (loggedInUserIdentifiers.names.has(empNameLower)) {
                return false;
            }

            // 3. Check partial name matches (e.g. if user is "Nisha" and employee is "Nisha Patel" or vice versa)
            for (let name of loggedInUserIdentifiers.names) {
                if (!name || name === 'employee user' || name === 'employee') continue;
                if (empNameLower === name) return false;
                if (name.length >= 3 && (empNameLower.startsWith(name + ' ') || name.startsWith(empNameLower + ' '))) {
                    return false;
                }
            }

            return true;
        });

        return list.sort((a, b) => a.name.localeCompare(b.name));
    }, [dbEmployees, awardTeams, loggedInUserIdentifiers]);

    // Determine which team in awardTeams the logged-in user belongs to based on Team Structure
    const currentUserTeam = React.useMemo(() => {
        if (!awardTeams || awardTeams.length === 0) return null;

        // 1. Try matching logged-in user in team.employees by ID or name
        for (const team of awardTeams) {
            if (Array.isArray(team.employees)) {
                const match = team.employees.some(emp => {
                    const empId = emp.id ? String(emp.id).toLowerCase().trim() : (emp.emp_id ? String(emp.emp_id).toLowerCase().trim() : '');
                    const empName = (emp.full_name || `${emp.first_name || ''} ${emp.last_name || ''}`).trim().toLowerCase();

                    if (empId && loggedInUserIdentifiers.ids.has(empId)) return true;
                    if (empName && loggedInUserIdentifiers.names.has(empName)) return true;
                    return false;
                });
                if (match) return team;
            }
        }

        // 2. Fallback: match by user's department in team.departments
        const userDept = (userData?.Department || userData?.department || userData?.dept || '').trim().toLowerCase();
        if (userDept) {
            for (const team of awardTeams) {
                if (Array.isArray(team.departments)) {
                    const deptMatch = team.departments.some(d => d.trim().toLowerCase() === userDept);
                    if (deptMatch) return team;
                }
            }
        }

        return null;
    }, [awardTeams, loggedInUserIdentifiers, userData]);

    // Live search filter for employee selector list
    const filteredEmpOptions = useMemo(() => {
        let list = allEmployeeOptions;

        // For Group 2 Awards (Team-Wise Awards), restrict nomination options to logged-in user's team members
        const isGroup2 = selectedCategory && GROUP_2_CATEGORY_IDS.has(selectedCategory.id);
        if (isGroup2) {
            if (currentUserTeam) {
                const teamMemberNames = new Set(
                    (currentUserTeam.employees || []).map(e => (e.full_name || `${e.first_name || ''} ${e.last_name || ''}`).trim().toLowerCase())
                );
                const teamMemberIds = new Set(
                    (currentUserTeam.employees || []).map(e => String(e.id || e.emp_id || '').trim().toLowerCase()).filter(Boolean)
                );
                const teamDepts = new Set((currentUserTeam.departments || []).map(d => d.trim().toLowerCase()));

                list = list.filter(emp => {
                    const empName = (emp.name || '').trim().toLowerCase();
                    const empId = emp.id ? String(emp.id).trim().toLowerCase() : '';
                    const empDept = (emp.dept || '').trim().toLowerCase();

                    const isNameMatch = teamMemberNames.has(empName);
                    const isIdMatch = empId && teamMemberIds.has(empId);
                    const isDeptMatch = empDept && teamDepts.has(empDept);

                    return isNameMatch || isIdMatch || isDeptMatch;
                });
            } else {
                // If user is not listed in any team, show empty list
                list = [];
            }
        }

        if (!empSearchQuery) return list;
        const q = empSearchQuery.toLowerCase().trim();
        return list.filter(o =>
            o.name.toLowerCase().includes(q) ||
            (o.dept && o.dept.toLowerCase().includes(q)) ||
            (o.role && o.role.toLowerCase().includes(q))
        );
    }, [allEmployeeOptions, empSearchQuery, selectedCategory, currentUserTeam]);

    // Fetch employee list from backend get_employees.php
    useEffect(() => {
        fetch('/gt-api/get_employees.php', { credentials: 'include' })
            .then(res => res.json())
            .then(data => {
                if (data.success && Array.isArray(data.employees)) {
                    setDbEmployees(data.employees);
                }
            })
            .catch(() => { });
    }, []);

    // Fetch 3 teams and roster from backend get_teams.php
    useEffect(() => {
        fetch('/gt-api/get_teams.php', { credentials: 'include' })
            .then(res => res.json())
            .then(data => {
                if (data.success && Array.isArray(data.teams) && data.teams.length > 0) {
                    const iconMap = {
                        'software_team': '💻',
                        'bim_team': '🏗️',
                        'fi_design_team': '🎨'
                    };
                    const updated = data.teams.map(t => ({
                        ...t,
                        icon: iconMap[t.team_key] || '👥'
                    }));
                    setAwardTeams(updated);
                }
            })
            .catch(err => console.error('Failed to fetch award teams:', err));
    }, []);

    // Fetch nominations from database elmsdb via backend get_award_nominations.php
    useEffect(() => {
        fetch('/gt-api/get_award_nominations.php', { credentials: 'include' })
            .then(res => res.json())
            .then(data => {
                if (data.success && Array.isArray(data.nominations) && data.nominations.length > 0) {
                    setNominations(data.nominations);
                }
            })
            .catch(err => console.error('Failed to fetch award nominations from elmsdb database:', err));
    }, []);

    useEffect(() => {
        localStorage.setItem('gte_3rd_anniversary_nominations', JSON.stringify(nominations));
    }, [nominations]);

    useEffect(() => {
        localStorage.setItem('gte_3rd_anniversary_hof', JSON.stringify(hallOfFame));
    }, [hallOfFame]);

    const handleOpenNominate = (category) => {
        const cat = category || ALL_CATEGORIES[0];
        setSelectedCategory(cat);
        setEmpSearchQuery('');
        setIsEmpDropdownOpen(false);

        // Check if current user already nominated someone for this category
        const existing = nominations.find(n =>
            n.categoryId === cat.id &&
            n.nominatorName.toLowerCase() === currentUserName.toLowerCase()
        );

        if (existing) {
            setFormData({
                nomineeName: existing.nomineeName || '',
                nomineeRole: existing.nomineeRole || '',
                categoryId: cat.id,
                reason: existing.reason || ''
            });
        } else {
            setFormData({
                nomineeName: '',
                nomineeRole: '',
                categoryId: cat.id,
                reason: ''
            });
        }
        setShowNominateModal(true);
    };

    const handleSubmitNomination = (e) => {
        e.preventDefault();
        if (!formData.nomineeName || !formData.reason) {
            alert('Please enter the nominee name and reason for nomination.');
            return;
        }

        // Self-nomination validation
        const nomineeLower = formData.nomineeName.trim().toLowerCase();
        for (let name of loggedInUserIdentifiers.names) {
            if (name && name !== 'employee user' && name !== 'employee') {
                if (nomineeLower === name || (name.length >= 3 && nomineeLower.startsWith(name + ' '))) {
                    alert('Self-nomination is not allowed. You cannot nominate yourself for an award.');
                    return;
                }
            }
        }

        const categoryObj = ALL_CATEGORIES.find(c => c.id === formData.categoryId) || selectedCategory;

        const newNomination = {
            nomineeName: formData.nomineeName,
            nomineeRole: formData.nomineeRole || 'Team Member',
            categoryId: categoryObj.id,
            categoryName: categoryObj.name,
            nominatorName: currentUserName,
            nominatorRole: role,
            reason: formData.reason,
            status: 'PENDING_REVIEW',
            submittedAt: new Date().toISOString().split('T')[0]
        };

        // Submit to database elmsdb via PHP API
        fetch('/gt-api/save_award_nomination.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newNomination),
            credentials: 'include'
        })
            .then(res => res.json())
            .then(data => {
                if (data.success && data.nomination) {
                    setNominations(prev => {
                        const filtered = prev.filter(n => !(n.categoryId === categoryObj.id && n.nominatorName.toLowerCase() === currentUserName.toLowerCase()));
                        return [data.nomination, ...filtered];
                    });
                } else {
                    const fallbackNom = { ...newNomination, id: `nom-${Date.now()}` };
                    setNominations(prev => {
                        const filtered = prev.filter(n => !(n.categoryId === categoryObj.id && n.nominatorName.toLowerCase() === currentUserName.toLowerCase()));
                        return [fallbackNom, ...filtered];
                    });
                }
            })
            .catch(err => {
                console.error("Save nomination API error, fallback to local:", err);
                const fallbackNom = { ...newNomination, id: `nom-${Date.now()}` };
                setNominations(prev => {
                    const filtered = prev.filter(n => !(n.categoryId === categoryObj.id && n.nominatorName.toLowerCase() === currentUserName.toLowerCase()));
                    return [fallbackNom, ...filtered];
                });
            });

        setShowNominateModal(false);
        alert(`🎉 Nomination for "${formData.nomineeName}" submitted successfully!`);
    };

    // Manager Action: Endorse Nomination
    const handleEndorseNomination = (nominationId) => {
        const comment = endorsementComment || 'Strongly endorsed by manager.';

        fetch('/gt-api/update_award_nomination_status.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: nominationId,
                status: 'MANAGER_ENDORSED',
                endorsementComment: comment
            }),
            credentials: 'include'
        }).catch(err => console.error("Failed to update status in DB:", err));

        setNominations(prev => prev.map(item => {
            if (item.id === nominationId) {
                return {
                    ...item,
                    status: 'MANAGER_ENDORSED',
                    endorsementComment: comment
                };
            }
            return item;
        }));
        setEndorseModalItem(null);
        setEndorsementComment('');
    };

    // Management Action: Declare Winner
    const handleDeclareWinner = (item) => {
        if (window.confirm(`Declare ${item.nomineeName} as WINNER for "${item.categoryName}"?`)) {

            fetch('/gt-api/update_award_nomination_status.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: item.id,
                    status: 'WINNER_DECLARED'
                }),
                credentials: 'include'
            }).catch(err => console.error("Failed to update winner status in DB:", err));

            setNominations(prev => prev.map(n => n.id === item.id ? { ...n, status: 'WINNER_DECLARED' } : n));

            const newWinner = {
                id: `hof-${Date.now()}`,
                winnerName: item.nomineeName,
                role: item.nomineeRole,
                awardTitle: `${item.categoryName} - 3rd Anniversary Honors`,
                icon: '🏆',
                citation: item.reason
            };
            setHallOfFame(prev => [newWinner, ...prev]);
        }
    };

    // Filtered nominations
    const mySubmissions = nominations.filter(n => n.nominatorName.toLowerCase() === currentUserName.toLowerCase());
    const pendingEndorsements = nominations.filter(n => n.status === 'PENDING_REVIEW');

    // Management Dashboard Analytics Computations
    const analyticsStats = useMemo(() => {
        const total = nominations.length;
        const pending = nominations.filter(n => n.status === 'PENDING_REVIEW').length;
        const endorsed = nominations.filter(n => n.status === 'MANAGER_ENDORSED').length;
        const winners = nominations.filter(n => n.status === 'WINNER_DECLARED').length;

        // Count per category
        const catMap = {};
        ALL_CATEGORIES.forEach(c => {
            catMap[c.id] = { id: c.id, name: c.name, icon: c.icon, badge: c.badge, count: 0 };
        });
        nominations.forEach(n => {
            if (catMap[n.categoryId]) {
                catMap[n.categoryId].count++;
            } else {
                catMap[n.categoryId] = { id: n.categoryId, name: n.categoryName || n.categoryId, icon: '🏆', badge: 'Award', count: 1 };
            }
        });

        const categoryBreakdown = Object.values(catMap).sort((a, b) => b.count - a.count);

        // Top Nominated Employees Leaderboard
        const nomMap = {};
        nominations.forEach(n => {
            const key = (n.nomineeName || '').trim();
            if (!key) return;
            if (!nomMap[key]) {
                nomMap[key] = {
                    name: key,
                    role: n.nomineeRole || 'Team Member',
                    count: 0,
                    categories: new Set()
                };
            }
            nomMap[key].count++;
            nomMap[key].categories.add(n.categoryName);
        });

        const topNominees = Object.values(nomMap)
            .map(item => ({ ...item, categories: Array.from(item.categories) }))
            .sort((a, b) => b.count - a.count)
            .slice(0, 5);

        return {
            total,
            pending,
            endorsed,
            winners,
            categoryBreakdown,
            topNominees
        };
    }, [nominations]);

    const pagesList = [
        { id: 'page-1-intro', title: '1. Event Intro & Award Guide', icon: '🎊' },
        { id: 'page-2-categories', title: '2. Award Nominations Grid', icon: '🏆' },
        { id: 'page-3-my-submissions', title: '3. My Submissions', icon: '📜' },
        ...(role === 'Manager' || role === 'Management' ? [{ id: 'page-4-endorsements', title: '4. Team Endorsements', icon: '👥' }] : []),
        ...(role === 'Management' ? [{ id: 'page-5-admin', title: '5. Ceremony Admin', icon: '⚙️' }] : []),
        { id: 'page-6-hall-of-fame', title: '6. Wall of Fame', icon: '🌟' }
    ];

    const currentPageIndex = pagesList.findIndex(p => p.id === currentPage);

    return (
        <div className={`award-container ${isDarkTheme ? 'dark-theme' : 'light-theme'}`}>
            {/* PAGE 1: CLASSIC EVENT INTRO, TEAM CATEGORIZATION & AWARD GUIDE */}
            {currentPage === 'page-1-intro' && (
                <div className="classic-intro-page">
                    {/* ANIMATED CLASSIC HERO TITLE SECTION */}
                    <header className="classic-hero-banner">
                        <div className="classic-badge-pill">
                            ✨ Genesis Tech Engineers • 3rd Anniversary & Award Ceremony
                        </div>
                        <h1 className="classic-main-title">
                            Celebrating 3 Years of Excellence
                        </h1>
                        <div className="classic-gold-divider"></div>
                        <p className="classic-lead-text">
                            Welcome to the official 3rd Anniversary Excellence Award. Explore how our departments and teams are structured, read the detailed meanings of all 9 company awards, and nominate outstanding colleagues.
                        </p>
                    </header>

                    {/* SECTION 1: AWARDS & THEIR DETAILED MEANINGS (TOP) */}
                    <section className="classic-section">
                        <div className="classic-section-header">
                            <h2 className="classic-section-title">
                                🏆Award Categories & Criteria
                            </h2>
                            <p className="classic-section-subtitle">
                                Complete criteria and official meanings for all 9 awards across our 3 honor groups.
                            </p>
                        </div>

                        {AWARD_GROUPS.map((group) => (
                            <div key={group.groupNumber} className="classic-award-group">
                                <div className="classic-group-heading">
                                    <span className="classic-group-num">{group.groupIcon} Group {group.groupNumber}</span>
                                    <h3 className="classic-group-title">{group.groupTitle}</h3>
                                    <span className="classic-group-tag">{group.countLabel}</span>
                                </div>
                                <p className="classic-group-desc">{group.groupDesc}</p>

                                <div className="classic-awards-linear-list">
                                    {group.categories.map((cat) => {
                                        const existingNom = nominations.find(n =>
                                            n.categoryId === cat.id &&
                                            (n.nominatorName || '').toLowerCase() === currentUserName.toLowerCase()
                                        );
                                        return (
                                            <div key={cat.id} className="classic-award-item">
                                                <div className="classic-award-header-line">
                                                    <h4 className="classic-award-name">
                                                        <span className="cat-icon-bullet">{cat.icon}</span> {cat.name}
                                                    </h4>
                                                    <div className="classic-award-actions" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                        {cat.isManagementOnly ? (
                                                            <span style={{
                                                                background: isDarkTheme ? 'rgba(234, 179, 8, 0.15)' : '#fffbe8',
                                                                color: isDarkTheme ? '#fde047' : '#92400e',
                                                                border: isDarkTheme ? '1px solid rgba(234, 179, 8, 0.4)' : '1px solid #fde047',
                                                                padding: '6px 14px',
                                                                borderRadius: '20px',
                                                                fontSize: '0.85rem',
                                                                fontWeight: '700',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '6px',
                                                                boxShadow: '0 1px 3px rgba(146, 64, 14, 0.1)'
                                                            }}>
                                                                🏛️ Selected by Management
                                                            </span>
                                                        ) : existingNom ? (
                                                            <>
                                                                <span style={{
                                                                    background: isDarkTheme ? 'rgba(34, 197, 94, 0.2)' : '#dcfce7',
                                                                    color: isDarkTheme ? '#4ade80' : '#15803d',
                                                                    border: isDarkTheme ? '1px solid rgba(74, 222, 128, 0.3)' : '1px solid #86efac',
                                                                    padding: '5px 12px',
                                                                    borderRadius: '20px',
                                                                    fontSize: '0.85rem',
                                                                    fontWeight: '700',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '4px'
                                                                }}>
                                                                    ✓ Nominated: {existingNom.nomineeName}
                                                                </span>
                                                                <button
                                                                    className="classic-btn-nominate"
                                                                    style={{
                                                                        background: isDarkTheme ? '#334155' : '#e2e8f0',
                                                                        color: isDarkTheme ? '#f8fafc' : '#0f172a',
                                                                        border: isDarkTheme ? '1px solid #475569' : '1px solid #cbd5e1'
                                                                    }}
                                                                    onClick={() => handleOpenNominate(cat)}
                                                                >
                                                                    Change Nomination ✏️
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="classic-badge-accent">✦ {cat.badge}</span>
                                                                <button
                                                                    className="classic-btn-nominate"
                                                                    onClick={() => handleOpenNominate(cat)}
                                                                >
                                                                    Nominate ✦
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <p className="classic-award-meaning">
                                                    {cat.description}
                                                </p>
                                                {cat.isManagementOnly && (
                                                    <>
                                                        <div style={{
                                                            marginTop: '12px',
                                                            padding: '10px 14px',
                                                            background: isDarkTheme ? 'rgba(234, 179, 8, 0.1)' : '#fffbeb',
                                                            borderLeft: '4px solid #d97706',
                                                            borderRadius: '6px',
                                                            fontSize: '0.85rem',
                                                            color: isDarkTheme ? '#fef08a' : '#78350f',
                                                            fontWeight: '600',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }}>
                                                            <span style={{ fontSize: '1.1rem' }}>📌</span>
                                                            <span><strong>Management Selection Note:</strong> This award is evaluated and determined directly by management leadership, based on overall team performance, collaboration, and collective contribution.</span>
                                                        </div>

                                                        <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    const elem = document.getElementById('team-structure-section');
                                                                    if (elem) {
                                                                        elem.scrollIntoView({ behavior: 'smooth' });
                                                                    }
                                                                }}
                                                                style={{
                                                                    background: isDarkTheme ? 'rgba(59, 130, 246, 0.18)' : '#eff6ff',
                                                                    color: isDarkTheme ? '#93c5fd' : '#1d4ed8',
                                                                    border: isDarkTheme ? '1px solid rgba(59, 130, 246, 0.4)' : '1px solid #bfdbfe',
                                                                    padding: '8px 16px',
                                                                    borderRadius: '8px',
                                                                    fontSize: '0.84rem',
                                                                    fontWeight: '700',
                                                                    cursor: 'pointer',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <span>🏢 View Teams Eligible For This Award</span>
                                                                <span style={{ fontSize: '1rem', fontWeight: '900' }}>↓</span>
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </section>

                    {/* SECTION 2: HOW TEAMS & TEAM MEMBERS ARE CATEGORIZED (BELOW) */}
                    <section id="team-structure-section" className="classic-section" style={{ marginTop: '48px' }}>
                        <div className="classic-section-header">
                            <h2 className="classic-section-title" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                🏢 Team Structure & Member Directory
                                <span style={{
                                    fontSize: '0.78rem',
                                    background: isDarkTheme ? 'rgba(234, 179, 8, 0.2)' : '#fef3c7',
                                    color: isDarkTheme ? '#fde047' : '#92400e',
                                    border: isDarkTheme ? '1px solid rgba(234, 179, 8, 0.4)' : '1px solid #fcd34d',
                                    padding: '3px 10px',
                                    borderRadius: '12px',
                                    fontWeight: '700'
                                }}>
                                    🏆 Eligible Teams for Best Team Award
                                </span>
                            </h2>
                            <p className="classic-section-subtitle">
                                Employees are dynamically categorized into 3 specialized teams based on their assigned departments.These teams are evaluated for the Best Team Award.
                            </p>
                        </div>

                        <div className="classic-teams-list">
                            {awardTeams.map((team) => {
                                const visibleEmployees = (team.employees || []).filter(emp => {
                                    const nameLower = (emp.full_name || `${emp.first_name || ''} ${emp.last_name || ''}`).trim().toLowerCase();
                                    const isExcluded =
                                        nameLower.includes('aron') ||
                                        nameLower.includes('fisher') ||
                                        nameLower.includes('sandeep') ||
                                        nameLower.includes('potti') ||
                                        nameLower.includes('ankur') ||
                                        nameLower.includes('shubham') ||
                                        nameLower.includes('neeta') ||
                                        nameLower.includes('ganesh') ||
                                        (nameLower.includes('rakesh') && nameLower.includes('sharma')) ||
                                        nameLower.includes('sunita') ||
                                        nameLower.includes('shantaram');
                                    return !isExcluded;
                                });

                                return (
                                    <div key={team.team_key} className="classic-team-row">
                                        <div className="classic-team-meta">
                                            <div className="classic-team-title-row">
                                                <span className="classic-team-icon">{team.icon}</span>
                                                <h3 className="classic-team-name">{team.team_name}</h3>
                                                <span className="classic-member-count">
                                                    {visibleEmployees.length} Members
                                                </span>
                                            </div>

                                            <div className="classic-dept-criteria">
                                                <span className="criteria-label">Categorized Depts:</span>
                                                {(team.departments || []).map((dept, i) => (
                                                    <span key={i} className="classic-dept-tag">{dept}</span>
                                                ))}
                                            </div>
                                        </div>

                                        {/* MEMBERS LIST UNDER THIS TEAM */}
                                        <div className="classic-members-list">
                                            {visibleEmployees.length > 0 ? (
                                                visibleEmployees.map((emp, i) => (
                                                    <div key={emp.id || i} className="classic-member-pill">
                                                        <div className="classic-member-avatar">
                                                            {(emp.full_name || emp.first_name || 'U').charAt(0).toUpperCase()}
                                                        </div>
                                                        <div className="classic-member-info">
                                                            <span className="classic-member-fullname">
                                                                {emp.full_name || `${emp.first_name || ''} ${emp.last_name || ''}`.trim()}
                                                            </span>
                                                            <span className="classic-member-desig">
                                                                {emp.designation || 'Team Member'} • <strong style={{ color: isDarkTheme ? '#fef08a' : '#d97706', fontWeight: '700' }}>{emp.department}</strong>
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="classic-empty-members">
                                                    No members listed under this team criteria in database.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </section>
                </div>
            )}

            {/* PAGE 2: AWARD NOMINATIONS GRID ONLY */}
            {currentPage === 'page-2-categories' && (
                <div className="awards-page-container">
                    <div>
                        <h2 className="page-header-title">🏆 Award Nominations Cards Grid (Page 2)</h2>
                        <p className="page-header-sub">
                            Select any of the 9 awards below to launch a nomination for an outstanding peer or team.
                        </p>
                    </div>

                    {AWARD_GROUPS.map((group) => (
                        <div key={group.groupNumber} className="award-group-section">
                            <div className="group-header">
                                <div className="group-icon">{group.groupIcon}</div>
                                <div>
                                    <h2 className="group-title">
                                        {group.groupNumber}) {group.groupTitle} ({group.countLabel})
                                    </h2>
                                    <p className="group-desc">{group.groupDesc}</p>
                                </div>
                            </div>

                            <div className="categories-grid">
                                {group.categories.map(cat => {
                                    const existingNom = nominations.find(n =>
                                        n.categoryId === cat.id &&
                                        (n.nominatorName || '').toLowerCase() === currentUserName.toLowerCase()
                                    );
                                    return (
                                        <div key={cat.id} className="category-card">
                                            <div>
                                                <div className="card-top-header">
                                                    <div className="category-icon-wrapper">{cat.icon}</div>
                                                    <h3 className="category-name">{cat.name}</h3>
                                                </div>
                                                <p className="category-desc">{cat.description}</p>
                                                {cat.isManagementOnly && (
                                                    <>
                                                        <div style={{
                                                            marginTop: '10px',
                                                            padding: '8px 12px',
                                                            background: isDarkTheme ? 'rgba(234, 179, 8, 0.1)' : '#fffbeb',
                                                            borderLeft: '4px solid #d97706',
                                                            borderRadius: '6px',
                                                            fontSize: '0.82rem',
                                                            color: isDarkTheme ? '#fef08a' : '#78350f',
                                                            fontWeight: '600'
                                                        }}>
                                                            📌 <strong>Management Selection:</strong> Evaluated & decided directly by leadership.
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setCurrentPage('page-1-intro');
                                                                setTimeout(() => {
                                                                    document.getElementById('team-structure-section')?.scrollIntoView({ behavior: 'smooth' });
                                                                }, 100);
                                                            }}
                                                            style={{
                                                                marginTop: '8px',
                                                                background: isDarkTheme ? 'rgba(59, 130, 246, 0.15)' : '#eff6ff',
                                                                color: isDarkTheme ? '#93c5fd' : '#1d4ed8',
                                                                border: isDarkTheme ? '1px solid rgba(59, 130, 246, 0.3)' : '1px solid #bfdbfe',
                                                                padding: '6px 12px',
                                                                borderRadius: '6px',
                                                                fontSize: '0.8rem',
                                                                fontWeight: '700',
                                                                cursor: 'pointer',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                gap: '6px',
                                                                width: '100%'
                                                            }}
                                                        >
                                                            <span>🏢 View Teams & Directory</span>
                                                            <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>↓</span>
                                                        </button>
                                                    </>
                                                )}
                                            </div>

                                            <div className="category-footer" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '8px' }}>
                                                {cat.isManagementOnly ? (
                                                    <div style={{
                                                        background: isDarkTheme ? 'rgba(234, 179, 8, 0.18)' : '#fef9c3',
                                                        color: isDarkTheme ? '#fde047' : '#854d0e',
                                                        border: isDarkTheme ? '1px solid rgba(234, 179, 8, 0.4)' : '1px solid #fde047',
                                                        padding: '10px 12px',
                                                        borderRadius: '8px',
                                                        fontSize: '0.85rem',
                                                        fontWeight: '700',
                                                        textAlign: 'center',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '6px'
                                                    }}>
                                                        🏛️ Selected Directly by Management
                                                    </div>
                                                ) : existingNom ? (
                                                    <div>
                                                        <div style={{
                                                            background: isDarkTheme ? 'rgba(34, 197, 94, 0.2)' : '#dcfce7',
                                                            color: isDarkTheme ? '#4ade80' : '#15803d',
                                                            border: isDarkTheme ? '1px solid rgba(74, 222, 128, 0.3)' : '1px solid #86efac',
                                                            padding: '6px 10px',
                                                            borderRadius: '8px',
                                                            fontSize: '0.82rem',
                                                            fontWeight: '700',
                                                            marginBottom: '8px',
                                                            textAlign: 'center'
                                                        }}>
                                                            ✓ Nominated: {existingNom.nomineeName}
                                                        </div>
                                                        <button
                                                            className="btn-secondary"
                                                            style={{ width: '100%', padding: '8px 12px', fontSize: '0.85rem' }}
                                                            onClick={() => handleOpenNominate(cat)}
                                                        >
                                                            Change Nomination ✏️
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <span className="award-badge-tag">✦ {cat.badge}</span>
                                                        <button
                                                            className="btn-nominate"
                                                            onClick={() => handleOpenNominate(cat)}
                                                        >
                                                            Nominate ✦
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}

                    <div className="page-bottom-nav">
                        <button
                            className="btn-secondary"
                            onClick={() => setCurrentPage('page-1-intro')}
                        >
                            ← Back to Event Intro (Page 1)
                        </button>
                        <button
                            className="btn-primary"
                            onClick={() => setCurrentPage('page-3-my-submissions')}
                        >
                            Next: View My Submissions (Page 3) →
                        </button>
                    </div>
                </div>
            )}

            {/* PAGE 3: MY SUBMISSIONS ONLY */}
            {currentPage === 'page-3-my-submissions' && (
                <div className="awards-page-container">
                    <h2 className="page-header-title">📜 Nominations Submitted by You (Page 3)</h2>
                    <p className="page-header-sub">Track the status of all nominations you have submitted for the 3rd Anniversary Gala.</p>

                    {mySubmissions.length === 0 ? (
                        <div className="empty-state">
                            You haven't submitted any nominations yet. Go to Page 1 or Page 2 to select an award and nominate a colleague!
                        </div>
                    ) : (
                        <div className="table-wrapper">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Nominee / Team</th>
                                        <th>Role / Dept</th>
                                        <th>Award Category</th>
                                        <th>Submitted Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mySubmissions.map(item => (
                                        <tr key={item.id}>
                                            <td><strong>{item.nomineeName}</strong></td>
                                            <td>{item.nomineeRole}</td>
                                            <td>{item.categoryName}</td>
                                            <td>{item.submittedAt}</td>
                                            <td>
                                                <span className={`status-badge ${item.status.toLowerCase().replace('_', '-')}`}>
                                                    {item.status.replace('_', ' ')}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className="page-bottom-nav">
                        <button
                            className="btn-secondary"
                            onClick={() => setCurrentPage('page-2-categories')}
                        >
                            ← Back to Award Grid (Page 2)
                        </button>
                        <button
                            className="btn-primary"
                            onClick={() => setCurrentPage(pagesList[currentPageIndex + 1]?.id || 'page-6-hall-of-fame')}
                        >
                            Next Page →
                        </button>
                    </div>
                </div>
            )}

            {/* PAGE 4: MANAGER TEAM ENDORSEMENTS ONLY */}
            {currentPage === 'page-4-endorsements' && (role === 'Manager' || role === 'Management') && (
                <div className="awards-page-container">
                    <h2 className="page-header-title">👥 Team Nominations for Manager Endorsement (Page 4)</h2>
                    <p className="page-header-sub">Review employee nominations submitted by team members and attach manager recommendations.</p>

                    {pendingEndorsements.length === 0 ? (
                        <div className="empty-state">
                            No pending nominations awaiting manager endorsement at this time.
                        </div>
                    ) : (
                        <div className="table-wrapper">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Nominee / Team</th>
                                        <th>Award Category</th>
                                        <th>Nominator</th>
                                        <th>Reason & Key Achievements</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pendingEndorsements.map(item => (
                                        <tr key={item.id}>
                                            <td><strong>{item.nomineeName}</strong> ({item.nomineeRole})</td>
                                            <td>{item.categoryName}</td>
                                            <td>{item.nominatorName} ({item.nominatorRole})</td>
                                            <td style={{ maxWidth: '320px' }}>{item.reason}</td>
                                            <td>
                                                <button
                                                    className="btn-primary"
                                                    style={{ padding: '8px 14px', fontSize: '0.82rem' }}
                                                    onClick={() => setEndorseModalItem(item)}
                                                >
                                                    Endorse & Recommend
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className="page-bottom-nav">
                        <button
                            className="btn-secondary"
                            onClick={() => setCurrentPage('page-3-my-submissions')}
                        >
                            ← Back to My Submissions (Page 3)
                        </button>
                        <button
                            className="btn-primary"
                            onClick={() => setCurrentPage(pagesList[currentPageIndex + 1]?.id || 'page-6-hall-of-fame')}
                        >
                            Next Page →
                        </button>
                    </div>
                </div>
            )}

            {/* PAGE 5: MANAGEMENT ADMIN PANEL & ANALYTICS */}
            {currentPage === 'page-5-admin' && role === 'Management' && (
                <div className="awards-page-container">
                    <h2 className="page-header-title">📊 3rd Anniversary Management Analytics & Winner Selection (Page 5)</h2>
                    <p className="page-header-sub">Live database analytics from elmsdb, candidate nomination metrics, and official ceremony committee control panel.</p>

                    {/* TOP STATS ANALYTICS CARDS */}
                    <div className="award-analytics-stats-grid" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
                        gap: '16px',
                        marginBottom: '28px'
                    }}>
                        <div className="analytics-stat-card" style={{
                            background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
                            border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
                            borderRadius: '14px',
                            padding: '20px',
                            boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
                        }}>
                            <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Total Nominations
                            </div>
                            <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#f59e0b', marginTop: '6px' }}>
                                {analyticsStats.total}
                            </div>
                            <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
                                Saved in elmsdb database
                            </div>
                        </div>

                        <div className="analytics-stat-card" style={{
                            background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
                            border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
                            borderRadius: '14px',
                            padding: '20px',
                            boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
                        }}>
                            <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Pending Review
                            </div>
                            <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#3b82f6', marginTop: '6px' }}>
                                {analyticsStats.pending}
                            </div>
                            <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
                                Awaiting manager endorsement
                            </div>
                        </div>

                        <div className="analytics-stat-card" style={{
                            background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
                            border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
                            borderRadius: '14px',
                            padding: '20px',
                            boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
                        }}>
                            <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Manager Endorsed
                            </div>
                            <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#10b981', marginTop: '6px' }}>
                                {analyticsStats.endorsed}
                            </div>
                            <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
                                Recommended by leadership
                            </div>
                        </div>

                        <div className="analytics-stat-card" style={{
                            background: isDarkTheme ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : '#ffffff',
                            border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
                            borderRadius: '14px',
                            padding: '20px',
                            boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
                        }}>
                            <div style={{ fontSize: '0.85rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Winners Honored
                            </div>
                            <div style={{ fontSize: '2.2rem', fontWeight: '800', color: '#ec4899', marginTop: '6px' }}>
                                {analyticsStats.winners}
                            </div>
                            <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginTop: '4px' }}>
                                Declared for Gala Ceremony
                            </div>
                        </div>
                    </div>

                    {/* TWO-COLUMN ANALYTICS DETAILED BREAKDOWN */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px', marginBottom: '32px' }}>
                        {/* COLUMN 1: CATEGORY BREAKDOWN */}
                        <div style={{
                            background: isDarkTheme ? '#1e293b' : '#ffffff',
                            border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
                            borderRadius: '14px',
                            padding: '20px'
                        }}>
                            <h3 style={{ fontSize: '1.1rem', fontWeight: '800', color: isDarkTheme ? '#f8fafc' : '#0f172a', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span>🏆</span> Submissions by Award Category
                            </h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {analyticsStats.categoryBreakdown.map(cat => {
                                    const pct = analyticsStats.total > 0 ? Math.round((cat.count / analyticsStats.total) * 100) : 0;
                                    return (
                                        <div key={cat.id}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.88rem', fontWeight: '600', color: isDarkTheme ? '#e2e8f0' : '#334155', marginBottom: '4px' }}>
                                                <span>{cat.icon} {cat.name}</span>
                                                <span>{cat.count} nomination{cat.count !== 1 ? 's' : ''} ({pct}%)</span>
                                            </div>
                                            <div style={{ height: '8px', background: isDarkTheme ? '#0f172a' : '#f1f5f9', borderRadius: '4px', overflow: 'hidden' }}>
                                                <div style={{
                                                    height: '100%',
                                                    width: `${pct}%`,
                                                    background: 'linear-gradient(90deg, #f59e0b, #d97706)',
                                                    borderRadius: '4px',
                                                    transition: 'width 0.4s ease'
                                                }}></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* COLUMN 2: TOP NOMINATED EMPLOYEES LEADERBOARD */}
                        <div style={{
                            background: isDarkTheme ? '#1e293b' : '#ffffff',
                            border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0',
                            borderRadius: '14px',
                            padding: '20px'
                        }}>
                            <h3 style={{ fontSize: '1.1rem', fontWeight: '800', color: isDarkTheme ? '#f8fafc' : '#0f172a', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span>🌟</span> Top Nominated Candidates
                            </h3>
                            {analyticsStats.topNominees.length === 0 ? (
                                <div style={{ color: isDarkTheme ? '#94a3b8' : '#64748b', fontSize: '0.9rem', textAlign: 'center', padding: '20px' }}>
                                    No employee nominations recorded yet.
                                </div>
                            ) : (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {analyticsStats.topNominees.map((nom, i) => (
                                        <div key={i} style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '10px 14px',
                                            background: isDarkTheme ? '#0f172a' : '#f8fafc',
                                            borderRadius: '10px',
                                            border: isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0'
                                        }}>
                                            <div>
                                                <div style={{ fontWeight: '700', fontSize: '0.95rem', color: isDarkTheme ? '#f8fafc' : '#0f172a' }}>
                                                    {i + 1}. {nom.name}
                                                </div>
                                                <div style={{ fontSize: '0.8rem', color: isDarkTheme ? '#94a3b8' : '#64748b' }}>
                                                    {nom.role}
                                                </div>
                                            </div>
                                            <div style={{ textAlign: 'right' }}>
                                                <span style={{
                                                    background: isDarkTheme ? 'rgba(245, 158, 11, 0.2)' : '#fef3c7',
                                                    color: isDarkTheme ? '#fbbf24' : '#d97706',
                                                    padding: '4px 10px',
                                                    borderRadius: '20px',
                                                    fontWeight: '800',
                                                    fontSize: '0.85rem'
                                                }}>
                                                    {nom.count} Nomination{nom.count !== 1 ? 's' : ''}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <h3 style={{ fontSize: '1.2rem', fontWeight: '800', color: isDarkTheme ? '#f8fafc' : '#0f172a', marginBottom: '14px' }}>
                        📋 All Nominees Table & Winner Declaration
                    </h3>

                    <div className="table-wrapper">
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Nominee / Team</th>
                                    <th>Award Category</th>
                                    <th>Nominator</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nominations.map(item => (
                                    <tr key={item.id}>
                                        <td><strong>{item.nomineeName}</strong> ({item.nomineeRole})</td>
                                        <td>{item.categoryName}</td>
                                        <td>{item.nominatorName}</td>
                                        <td>
                                            <span className={`status-badge ${item.status.toLowerCase().replace('_', '-')}`}>
                                                {item.status.replace('_', ' ')}
                                            </span>
                                        </td>
                                        <td>
                                            {item.status !== 'WINNER_DECLARED' ? (
                                                <button
                                                    className="btn-nominate"
                                                    onClick={() => handleDeclareWinner(item)}
                                                >
                                                    👑 Declare Winner
                                                </button>
                                            ) : (
                                                <span style={{ color: '#4ade80', fontWeight: 'bold' }}>🎉 Honored Winner</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="page-bottom-nav">
                        <button
                            className="btn-secondary"
                            onClick={() => setCurrentPage('page-4-endorsements')}
                        >
                            ← Previous Page
                        </button>
                        <button
                            className="btn-primary"
                            onClick={() => setCurrentPage('page-6-hall-of-fame')}
                        >
                            Next: Wall of Fame (Page 6) →
                        </button>
                    </div>
                </div>
            )}

            {/* PAGE 6: WALL OF FAME ONLY */}
            {currentPage === 'page-6-hall-of-fame' && (
                <div className="awards-page-container">
                    <h2 className="page-header-title">🌟 Wall of Fame - 3rd Anniversary Honorees</h2>
                    <p className="page-header-sub">Celebrating official winners and honorees of the Genesis Tech Engineers Award Ceremony.</p>

                    <div className="hall-grid">
                        {hallOfFame.map(item => (
                            <div key={item.id} className="hall-card">
                                <div className="hall-trophy-icon">{item.icon}</div>
                                <h3 className="hall-winner-name">{item.winnerName}</h3>
                                <div className="hall-winner-role">{item.role}</div>
                                <span className="hall-award-title">{item.awardTitle}</span>
                                <p className="hall-citation">"{item.citation}"</p>
                            </div>
                        ))}
                    </div>

                    <div className="page-bottom-nav">
                        <button
                            className="btn-secondary"
                            onClick={() => setCurrentPage(pagesList[currentPageIndex - 1]?.id || 'page-1-intro')}
                        >
                            ← Previous Page
                        </button>
                        <button
                            className="btn-primary"
                            onClick={() => setCurrentPage('page-1-intro')}
                        >
                            Back to Event Intro (Page 1) ↺
                        </button>
                    </div>
                </div>
            )}

            {/* MODAL: SUBMIT NOMINATION (PORTAL TO BODY FOR TRUE VIEWPORT POPUP) */}
            {showNominateModal && ReactDOM.createPortal(
                <div className={`award-modal-overlay ${isDarkTheme ? 'dark-theme-modal' : 'light-theme-modal'}`}>
                    <div className="award-modal-card">
                        <div className="modal-header">
                            <h3 className="modal-title">
                                <span>{selectedCategory?.icon || '🏆'}</span> Nominate for {selectedCategory?.name}
                            </h3>
                            <button
                                className="btn-close-modal"
                                onClick={() => setShowNominateModal(false)}
                            >
                                ✕
                            </button>
                        </div>
                        <form onSubmit={handleSubmitNomination}>
                            <div className="form-group">
                                <label className="form-label" style={{ color: isDarkTheme ? '#fef08a' : '#b45309', fontWeight: '700', marginBottom: '8px', display: 'block' }}>
                                    Award Category Selected
                                </label>
                                <div
                                    className="selected-category-read-only"
                                    style={{
                                        padding: '12px 16px',
                                        borderRadius: '8px',
                                        background: isDarkTheme ? 'rgba(245, 158, 11, 0.12)' : '#fef3c7',
                                        border: isDarkTheme ? '1px solid rgba(245, 158, 11, 0.3)' : '1px solid #fde68a',
                                        color: isDarkTheme ? '#fbbf24' : '#92400e',
                                        fontWeight: '700',
                                        fontSize: '1.02rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}
                                >
                                    <span style={{ fontSize: '1.2rem' }}>{selectedCategory?.icon || '🏆'}</span>
                                    <span>{selectedCategory?.name || 'Employee of the Year'}</span>
                                </div>
                            </div>

                            {/* QUESTION 1 */}
                            <div className="form-group" style={{ marginTop: '22px' }}>
                                <label className="form-label" style={{ fontSize: '1.05rem', fontWeight: '800', color: isDarkTheme ? '#ffffff' : '#0f172a', marginBottom: '6px' }}>
                                    1) Who do you think deserves this award? <span style={{ color: '#ef4444' }}>*</span>
                                </label>
                                <div style={{ fontSize: '0.88rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginBottom: '10px' }}>
                                    Type name or select an employee from the list below:
                                </div>

                                {GROUP_2_CATEGORY_IDS.has(selectedCategory?.id) && (
                                    <div style={{
                                        marginBottom: '12px',
                                        padding: '10px 14px',
                                        borderRadius: '8px',
                                        background: isDarkTheme ? 'rgba(59, 130, 246, 0.18)' : '#eff6ff',
                                        border: isDarkTheme ? '1px solid rgba(59, 130, 246, 0.4)' : '1px solid #bfdbfe',
                                        color: isDarkTheme ? '#93c5fd' : '#1e40af',
                                        fontSize: '0.88rem',
                                        fontWeight: '600',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <span style={{ fontSize: '1.1rem' }}>👥</span>
                                        <span>
                                            {currentUserTeam ? (
                                                <><strong>Team-Wise Award Filter:</strong> Showing members of your assigned team (<strong>{currentUserTeam.icon} {currentUserTeam.team_name}</strong>).</>
                                            ) : (
                                                <><strong>Team-Wise Award Filter:</strong> You are not currently listed in any team under the Team Structure & Member Directory.</>
                                            )}
                                        </span>
                                    </div>
                                )}

                                {/* INDIVIDUAL EMPLOYEE AWARDS: SEARCHABLE EMPLOYEE DROPDOWN CONTAINER */}
                                <div style={{
                                    background: isDarkTheme ? '#0f172a' : '#ffffff',
                                    border: isDarkTheme ? '2px solid #f59e0b' : '2px solid #d97706',
                                    borderRadius: '14px',
                                    padding: '12px',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.15)'
                                }}>
                                    {/* Typing Search Field */}
                                    <div style={{ position: 'relative', marginBottom: '10px' }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="🔍 Type employee name, department, or role to search..."
                                            value={empSearchQuery}
                                            onChange={e => setEmpSearchQuery(e.target.value)}
                                            style={{
                                                fontSize: '0.95rem',
                                                padding: '11px 36px 11px 14px',
                                                borderRadius: '10px',
                                                background: isDarkTheme ? '#1e293b' : '#f8fafc',
                                                color: isDarkTheme ? '#f8fafc' : '#0f172a',
                                                border: isDarkTheme ? '1px solid #475569' : '1px solid #cbd5e1',
                                                fontWeight: '600',
                                                outline: 'none',
                                                width: '100%'
                                            }}
                                        />
                                        {empSearchQuery && (
                                            <button
                                                type="button"
                                                onClick={() => setEmpSearchQuery('')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '12px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    color: isDarkTheme ? '#94a3b8' : '#64748b',
                                                    cursor: 'pointer',
                                                    fontSize: '1rem'
                                                }}
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>

                                    {/* Selected Nominee Banner (inside container) */}
                                    {formData.nomineeName && (
                                        <div style={{
                                            marginBottom: '10px',
                                            padding: '10px 14px',
                                            borderRadius: '8px',
                                            background: isDarkTheme ? 'rgba(34, 197, 94, 0.15)' : '#dcfce7',
                                            border: isDarkTheme ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid #86efac',
                                            color: isDarkTheme ? '#4ade80' : '#15803d',
                                            fontWeight: '700',
                                            fontSize: '0.92rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <span>✓ Selected: <strong>{formData.nomineeName}</strong> {formData.nomineeRole && `(${formData.nomineeRole})`}</span>
                                            <button
                                                type="button"
                                                onClick={() => setFormData({ ...formData, nomineeName: '', nomineeRole: '' })}
                                                style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontWeight: '700', textDecoration: 'underline' }}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    )}

                                    {/* Direct Scrollable Employee Options List */}
                                    <div style={{
                                        maxHeight: '195px',
                                        overflowY: 'auto',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '5px',
                                        paddingRight: '2px'
                                    }}>
                                        {filteredEmpOptions.length === 0 ? (
                                            <div style={{ padding: '16px', textAlign: 'center', color: isDarkTheme ? '#94a3b8' : '#64748b', fontSize: '0.9rem' }}>
                                                No matching employees found for "{empSearchQuery}"
                                            </div>
                                        ) : (
                                            filteredEmpOptions.map((emp, i) => {
                                                const isSelected = formData.nomineeName === emp.name;
                                                return (
                                                    <div
                                                        key={i}
                                                        onClick={() => {
                                                            setFormData({
                                                                ...formData,
                                                                nomineeName: emp.name,
                                                                nomineeRole: `${emp.role}${emp.dept ? ' (' + emp.dept + ')' : ''}`
                                                            });
                                                        }}
                                                        style={{
                                                            padding: '10px 14px',
                                                            borderRadius: '8px',
                                                            cursor: 'pointer',
                                                            background: isSelected
                                                                ? (isDarkTheme ? 'rgba(245, 158, 11, 0.25)' : '#fef3c7')
                                                                : (isDarkTheme ? '#1e293b' : '#ffffff'),
                                                            border: isSelected
                                                                ? (isDarkTheme ? '1px solid #f59e0b' : '1px solid #d97706')
                                                                : (isDarkTheme ? '1px solid #334155' : '1px solid #e2e8f0'),
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            transition: 'all 0.15s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (!isSelected) {
                                                                e.currentTarget.style.background = isDarkTheme ? 'rgba(255, 255, 255, 0.05)' : '#f1f5f9';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (!isSelected) {
                                                                e.currentTarget.style.background = isDarkTheme ? '#1e293b' : '#ffffff';
                                                            }
                                                        }}
                                                    >
                                                        <div>
                                                            <div style={{ fontWeight: '700', fontSize: '0.95rem', color: isDarkTheme ? '#f8fafc' : '#0f172a' }}>
                                                                {emp.name}
                                                            </div>
                                                            <div style={{ fontSize: '0.82rem', color: isDarkTheme ? '#cbd5e1' : '#64748b', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                {emp.dept && (
                                                                    <span style={{
                                                                        background: isDarkTheme ? 'rgba(245, 158, 11, 0.15)' : '#fffbeb',
                                                                        color: isDarkTheme ? '#fbbf24' : '#d97706',
                                                                        border: isDarkTheme ? '1px solid rgba(245, 158, 11, 0.3)' : '1px solid #fde68a',
                                                                        padding: '1px 6px',
                                                                        borderRadius: '4px',
                                                                        fontWeight: '600'
                                                                    }}>
                                                                        {emp.dept}
                                                                    </span>
                                                                )}
                                                                <span>{emp.role}</span>
                                                            </div>
                                                        </div>
                                                        {isSelected ? (
                                                            <span style={{ color: isDarkTheme ? '#fbbf24' : '#d97706', fontWeight: '800', fontSize: '0.98rem' }}>✓ Selected</span>
                                                        ) : (
                                                            <span style={{ fontSize: '0.8rem', color: isDarkTheme ? '#94a3b8' : '#64748b', fontWeight: '600' }}>Select →</span>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* QUESTION 2 */}
                            <div className="form-group" style={{ marginTop: '22px' }}>
                                <label className="form-label" style={{ fontSize: '1.05rem', fontWeight: '800', color: isDarkTheme ? '#ffffff' : '#0f172a', marginBottom: '6px' }}>
                                    2) Why are you nominating this person?
                                </label>
                                <div style={{ fontSize: '0.88rem', color: isDarkTheme ? '#cbd5e1' : '#475569', marginBottom: '8px' }}>
                                    Write your detailed answer explaining their contributions:
                                </div>
                                <textarea
                                    className="form-textarea"
                                    placeholder="Write your answer explaining why this person deserves this award..."
                                    value={formData.reason}
                                    onChange={e => setFormData({ ...formData, reason: e.target.value })}
                                    required
                                    rows={5}
                                    style={{ fontSize: '0.95rem', minHeight: '140px' }}
                                />
                            </div>

                            <div className="modal-actions">
                                <button
                                    type="button"
                                    className="btn-secondary"
                                    onClick={() => setShowNominateModal(false)}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="btn-primary">
                                    Submit Nomination 🚀
                                </button>
                            </div>
                        </form>
                    </div>
                </div>,
                document.body
            )}

            {/* MODAL: MANAGER ENDORSEMENT */}
            {endorseModalItem && ReactDOM.createPortal(
                <div className={`award-modal-overlay ${isDarkTheme ? 'dark-theme-modal' : 'light-theme-modal'}`}>
                    <div className="award-modal-card">
                        <div className="modal-header">
                            <h3 className="modal-title">
                                👥 Endorse Nomination for {endorseModalItem.nomineeName}
                            </h3>
                            <button className="btn-close-modal" onClick={() => setEndorseModalItem(null)}>✕</button>
                        </div>
                        <div>
                            <p style={{ color: '#cbd5e1', fontSize: '0.9rem', marginBottom: '14px' }}>
                                <strong>Category:</strong> {endorseModalItem.categoryName}<br />
                                <strong>Nominated By:</strong> {endorseModalItem.nominatorName}<br />
                                <strong>Original Contribution Reason:</strong> "{endorseModalItem.reason}"
                            </p>
                            <div className="form-group">
                                <label className="form-label">Manager Endorsement Note / Recommendation</label>
                                <textarea
                                    className="form-textarea"
                                    placeholder="Add manager endorsement note for the committee..."
                                    value={endorsementComment}
                                    onChange={e => setEndorsementComment(e.target.value)}
                                />
                            </div>
                            <div className="modal-actions">
                                <button className="btn-secondary" onClick={() => setEndorseModalItem(null)}>Cancel</button>
                                <button
                                    className="btn-primary"
                                    onClick={() => handleEndorseNomination(endorseModalItem.id)}
                                >
                                    Endorse Nomination ✅
                                </button>
                            </div>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default AwardNominations;
